var custom = {
  mobileBreakPoint: 768,
  currentVariant: {},
  navItems: {},
  hoverState: {},
  currNostoPage: 0,
  default_lang: "fr",
  paginationCt: 48,
  maxSlideshows: 3,
  pageSet: false,
  isSearchPage: window.location.href.indexOf("/search") != -1,
  isCategoryPage: window.location.href.indexOf("/collections") != -1,
  isProductPage: window.location.href.indexOf("/products") != -1,
  isCartPage: window.location.href.indexOf("/cart") != -1,
  isHomePage: window.location.href.indexOf("/") == -1,
  isNotFoundPage: window.location.href.indexOf("/404") != -1,
  filtersArray: [],
  currCollectionId: '',
  filtersChecked: false,
  loadProducts: true,
  currAccountId: '',
  filters: {
    collectionId: "",
    pageNum: 0,
    sort: "",
    filter: null,
    filterValid: null,
  },
  isMobile: function () {
    return window.innerWidth <= this.mobileBreakPoint;
  },
  isMobileBrowser: function () {
    var hasTouchScreen = false;
    var UA = navigator.userAgent;
    hasTouchScreen =
      /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) ||
      /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA);

    if (hasTouchScreen) {
      return true;
    }
    return false;
  },
  updateDiscount: function (product_handle, variant_id, saved_amount, product) {
    let badge = product.closest(".product-card").querySelector(".badge");
    let badgeAmount = badge.querySelector(".badge-amount");
    if (saved_amount) {
      badge.style.display = "";
      badgeAmount.innerHTML = saved_amount;
    } else {
      badge.style.display = "none";
    }
    custom.currentVariant[product_handle] = variant_id;
  },
  removeFilter: function (currVal, currField) {
    let cbId = currField + currVal;
    let elem = document.getElementById(cbId);
    if (elem) {
      elem.checked = false;
      custom.refreshProducts();
      document.querySelector('.click-capture').click()
    }
    this.updateFilterUrl();
  },
  fetchLinkTemplate: function (linkName, linkField) {
    let removeLinkTemplate = `<a href="javascript:void(custom.removeFilter('${linkName}','${linkField}'));" class="active-facets__button">
    ${linkName}
		<span><svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7 1L1 7M7 7L1 1" stroke="var(--color-body)" stroke-linecap="round" stroke-linejoin="round"></path>
    </svg></span>
	  </a>`;
    return removeLinkTemplate
  },
  getFilterQuery: function (use_default) {
    let collectionId = this.currCollectionId;
    let categoryFilter = "";
    if (collectionId) {
      categoryFilter = `products:{
        categoryId:"${collectionId}"
        filter: ${custom.filters.filter}
      }`;
    }
    let accountId = custom.currAccountId;
    if (!accountId) {
      accountId = theme.settings.nostoId;
      if (use_default) {
        accountId = theme.settings.defaultNostoId;
      }
    }
    if (localStorage.getItem("use-default-account-id") == 1) {
      accountId = theme.settings.defaultNostoId;
    }
    let searchQuery = "";
    if (custom.getAttribute('q')) {
      searchQuery = `query: "${custom.getAttribute('q')}",`;
    }
    let query = `query {
      search(
        ${categoryFilter}${searchQuery}
        accountId: "${accountId}") {
        products {
          facets {
            ... on SearchTermsFacet {
              id
              field
              type
              name
              data {
                value
                count
              }
            }
          }
        }
      }
    }`;
    if (custom.getAttribute('debugrec')) {
      console.log('Filter Request Query:', query);
    }
    return query;
  },
  updateFilters: function () {
    let query = custom.getFilterQuery();
    fetch("https://search.nosto.com/v1/graphql", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        query: query,
      }),
    })
      .then((res) => res.json())
      .then((result) => {
        let errors = result.errors;
        if (errors && errors.length > 0) {
          console.error('Nosto API fetch failed with error: ' + JSON.stringify(errors, null, 4));
          return;
        }
        else if (result && result.data) {
          let facets = result.data.search.products.facets;
          if (facets && facets.length > 0) {
            facets.forEach((facet) => {
              let facetField = facet.field;
              let facetValues = facet.data;
              facetValues.forEach((item) => {
                let value = item.value;
                let count = item.count;
                let countElem = document.getElementById(`${facetField}${value}_ct`);
                countElem.innerHTML = `(${count})`;
              });
            });
          }
        }
      });

  },
  createFilters: function (collectionId, use_default) {
    if (!collectionId) {
      collectionId = this.currCollectionId;
    }
    this.currCollectionId = collectionId;

    let formElem = document.getElementById("FacetFiltersFormMobile2");
    if (formElem) {
      formElem.innerHTML = "";
      let query = custom.getFilterQuery(use_default);

      fetch("https://search.nosto.com/v1/graphql", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          query: query,
        }),
      })
        .then((res) => res.json())
        .then((result) => {

          let errors = result.errors;
          let hasError = false;
          if (errors && errors.length > 0) {
            hasError = true;
            console.error('Nosto API fetch failed with error: ' + JSON.stringify(errors, null, 4));
          }
          if (hasError) {
            if (!use_default) {
              custom.createFilters(collectionId, true);
              return;
            }
          }
          else if (result && result.data) {
            let facets = result.data.search.products.facets;
            if (facets && facets.length > 0) {
              facets.forEach((facet) => {
                if (!facet) {
                  return;
                }
                let facetName = facet.name;
                let facetField = facet.field;
                let facetValues = facet.data;
                let liHTML = "";
                if (facetValues && facetValues.length > 0) {
                  facetValues.forEach((item) => {
                    let value = item.value;
                    let count = item.count;
                    liHTML += `<li>
                <input type="checkbox" onclick="custom.updateFilterItem('${facetField}', '${value}');" class="filter-item" name="${facetField}" value="${value}" id="${facetField}${value}">
                <label for="${facetField}${value}" class="facet-checkbox" style="--bg-color: 1/2;" data-tooltip="${value} (${count})">
                  <span class="filter-color filter-1/2"></span>
                  <span class="filter-name">${value}</span> 
                  <span id="${facetField}${value}_ct" class="count">(${count})</span>
                </label>
                </li>`;
                  });
                }
                let categoryHTML = `
              <collapsible-row data-index="3">
                  <details class="thb-filter js-filter" open="">
                    <summary class="thb-filter-title">${facetName}<span>
                      <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 6.81818L7 0.818176L1 6.81818" stroke="var(--color-heading)" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>
                    </summary>
                  <div class="thb-filter-content collapsible__content">
                    <scroll-shadow>
                      <ul class="list-taille">${liHTML}</ul>
                    </scroll-shadow></div>
                </details>
              </collapsible-row>`;
                formElem.innerHTML += categoryHTML;
              });

            }
          }
          if (custom.loadProducts) {
            custom.loadProducts = false;
            custom.filterNostoProducts(collectionId, 'nostoProducts', "", 0)
          }
        });


    }
  },
  updateFilterItem: function () {
    this.refreshProducts();
    this.updateFilterUrl();
    custom.updateFilters();
  },
  updateFilterUrl: function (pageNum) {
    let responseUrl = "?filter=";
    if (this.filters.filterValid) {
      let json = JSON.parse(this.filters.filterValid);
      json.forEach((filter) => {
        let values = filter.value;
        let param = filter.field;
        responseUrl += `||${param}*${values}`
      });
    }
    if (custom.getAttribute('q')) {
      responseUrl += `&q=${custom.getAttribute('q')}`;
    }
    if (pageNum) {
      responseUrl += `&page=${pageNum}`;
    }
    window.history.pushState('page2', 'Title', responseUrl)
  },
  getAttribute: function (str) {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    return urlParams.get(str);
  },
  updateProductCardDefault: function (
    productId, image_url, image_url_small, secondary_image_url, secondary_image_url_small, title, url, price, handle, sib_id
  ) {
    let productCard = document.querySelector(`product-card[product-id='${productId}']`);
    //Load low res first so users dont wait to see image
    let imageElement = productCard.querySelector('.product-primary-image');
    if (imageElement) {
      imageElement.src = image_url_small;
      imageElement.srcset = image_url_small;
      imageElement.srcset = image_url;
      imageElement.src = image_url;
    }
    imageElement = productCard.querySelector('.product-secondary-image');
    if (imageElement) {
      imageElement.srcset = secondary_image_url_small;
      imageElement.srcset = secondary_image_url;
      imageElement.src = secondary_image_url_small;
      imageElement.src = secondary_image_url;
    }

    titleElement = productCard.querySelector('.product-card-title')
    cardAnchorElement = productCard.querySelector('.product-featured-image-link')
    titleElement.href = url;
    cardAnchorElement.href = url;
    titleElement.textContent = title;

    amountElement = productCard.querySelector('.amount');
    amountElement.textContent = price;

    quickViewElement = productCard.querySelector('.product-card-quickview');
    quickViewElement.setAttribute('data-product-handle', handle);

    let targetAnchor = productCard.querySelector(`a[sib-id="${sib_id}"]`);

    if (targetAnchor) {
      let parentLi = targetAnchor.parentElement;
      if (parentLi && parentLi.tagName.toLowerCase() === 'label') {

        let activeLi = productCard.querySelector('label.active');
        if (activeLi) {
          activeLi.classList.remove('active');
        }

        parentLi.classList.add('active');
      }
    }
  },
  updateProductCard: function (
    elem,
    productId,
    handle,
    sib_id
  ) {
    let productCard = elem.closest('product-card');
    let currentElement = productCard.parentNode;
    if (currentElement) {
      productCardElems.getPdpItem(handle, false, currentElement, true, productId);
    }
  },
  updateBreadCrumbs: function () {
    document.addEventListener("DOMContentLoaded", function () {
      var collectionContainer = document.getElementById("collection_container");
      var urlParams = new URLSearchParams(window.location.search);
      var collectionHandle = urlParams.get("collection_handle");
      var collectionName = urlParams.get("collection_name");
      const localData = localStorage.getItem("current_collection");
      if (localData) {
        let json = JSON.parse(localData);
        collectionName = json.name ? json.name : collectionName;
        collectionHandle = json.handle ? json.handle : collectionHandle;
      }
      if (collectionContainer && collectionName && collectionHandle) {
        collectionContainer.style.display = "block";
        var breadcrumbAnchor = collectionContainer.querySelector(
          "#breadcrumb_collection"
        );
        if (breadcrumbAnchor) {
          breadcrumbAnchor.textContent = collectionName;
          let localePath = "";
          if (theme.settings.locale != "") {
            localePath = "/" + theme.settings.locale;
          }
          breadcrumbAnchor.href =
            localePath + "/collections/" + encodeURIComponent(collectionHandle);
        }
      }
    });
  },
  createNavigation: function (menu_key) {
    let setDate = custom.getAttribute('SETDATE');
    if (setDate) {
      const date = new Date(setDate); // Create a new Date object representing the current date and time
      const timestamp = date.getTime(); // Get the timestamp in milliseconds
      menu_key += '_' + timestamp.toString().slice(0, -3);
    }
    let storageKey = "navigation_" + menu_key + "_" + theme.settings.locale;
    let currentMenuStorage = sessionStorage.getItem(storageKey);

    //Check if the menu has been stored for over 5 minutes, if so then delete the storage and allow it to resave
    let now = Date.now();
    let before = sessionStorage.getItem("navigation_time");
    if (before) {
      let diff = now - before;
      if (diff > 300000) {
        sessionStorage.removeItem(storageKey);
        sessionStorage.removeItem("navigation_time");
      }
    }

    if (currentMenuStorage && !setDate) {
      let data = JSON.parse(currentMenuStorage);
      this.createDesktopNav(data);
      this.createMobileNav(data);
    } else {
      let fetchUrl = productCardElems.parsePageUrl("metaobject-api/nosto_navigation*" + menu_key);
      fetch(fetchUrl)
        .then((response) => response.json()) // parse each response as json
        .then((result) => {
          if (custom.getAttribute("debugnav")) {
            console.log('nav api result:', result);
          }
          if (result.nosto_navigation) {
            let data = result.nosto_navigation[0].data;
            if (data && data.nav_categories) {
              sessionStorage.setItem(storageKey, JSON.stringify(data));
              sessionStorage.setItem("navigation_time", now);
              this.createDesktopNav(data);
              this.createMobileNav(data);
            }
          }
        });
    }
  },
  toggleDiscount: function (className) {
    let discountDiv = document.getElementById(className);
    if (discountDiv.style.zIndex == -1) {
      discountDiv.style.zIndex = 100;
      discountDiv.style.visibility = "";
    } else {
      discountDiv.style.zIndex = -1;
    }
  },
  createDesktopNav: function (json) {
    let downArrow = `<svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.75 1.5L3.75 4.5L0.75 1.5" stroke="var(--color-header-links, --color-accent)" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"></path>
    </svg>`;
    let menuWrapper = document.createElement("ul");
    menuWrapper.setAttribute("class", "thb-full-menu");
    menuWrapper.setAttribute("role", "menubar");
    json.nav_categories.map((item) => {
      var li = document.createElement("li");
      li.setAttribute("role", "none");
      var a = document.createElement("a");
      a.setAttribute("role", "menuitem");
      let itemUrl = window.Shopify.routes.root.slice(0, -1) + item.url
        ? window.Shopify.routes.root.slice(0, -1) + item.url
        : "#";
      a.setAttribute("href", itemUrl);
      a.setAttribute("title", item.name);
      a.textContent = item.name;
      let itemColor = item.color;
      if (itemColor) {
        a.setAttribute("style", `color:${itemColor}`);
      }
      li.appendChild(a);
      let categories = item.categories;

      if (
        categories &&
        categories.length > 0 &&
        item.type == "navigation_categories"
      ) {
        a.innerHTML += downArrow;
        li.setAttribute(
          "class",
          "menu-item-has-children menu-item-has-megamenu"
        );
        var mainDiv = document.createElement("div");
        mainDiv.setAttribute("class", "sub-menu mega-menu-container");
        var nestedUl = document.createElement("ul");
        nestedUl.setAttribute("class", "mega-menu-columns");
        categories.map((category) => {
          if (category.type == "navigation_promos") {
            let promoTitle = category.promo_title;
            let promoImage = category.promo_image;
            let promoSubTitle = category.promo_subtitle
              ? category.promo_subtitle
              : "";
            let promoLink = category.promo_url ? category.promo_url : "#";
            if (promoTitle && promoImage) {
              nestedUl.innerHTML += `<li>
                      <div class="mega-menu-promotion">
                        <div class="mega-menu-promotion--image">
                          <img class="no-blur lazyautosizes lazyloaded" width="350" height="220" data-sizes="auto" src="${promoImage}" data-srcset="${promoImage}" fetchpriority="low" alt="" style="object-position: 50.0% 50.0%;" sizes="189px" srcset="${promoImage}">
                        </div>
                        <div class="mega-menu-promotion--content"><span class="h6">${promoTitle}</span><p>${promoSubTitle}</p></div><a href="${promoLink}" class="mega-menu-promotion--link"></a></div>
                    </li>`;
            }
          } else {
            let categoryLi = document.createElement("li");
            categoryLi.setAttribute("role", "none");
            if (category.mobile_only == 'true') {
              categoryLi.setAttribute('class', 'mobile_only');
            }
            let categoryTitleElem = document.createElement("a");
            categoryTitleElem.textContent = category.title;
            categoryTitleElem.href =
              window.Shopify.routes.root.slice(0, -1) + category.url
                ? window.Shopify.routes.root.slice(0, -1) + category.url
                : "#";

            categoryTitleElem.setAttribute(
              "class",
              "mega-menu-columns__heading navigation_level2"
            );
            categoryTitleElem.setAttribute("role", "menuitem");
            let categoryColor = category.color;
            if (categoryColor) {
              categoryTitleElem.setAttribute("style", `color:${categoryColor}`);
            }
            categoryLi.appendChild(categoryTitleElem);
            let categoryUl = document.createElement("ul");
            categoryUl.setAttribute("role", "menu");
            let items = category.items;
            items.map((item) => {
              let nestedLi = document.createElement("li");
              if (item.mobile_only == 'true') {
                nestedLi.setAttribute('class', 'mobile_only');
              }
              let nestedLink = document.createElement("a");
              nestedLink.setAttribute("class", "navigation_level3");
              nestedLink.setAttribute("role", "menuitem");
              nestedLink.textContent = item.name;
              nestedLink.href =
                window.Shopify.routes.root.slice(0, -1) + item.url
                  ? window.Shopify.routes.root.slice(0, -1) + item.url
                  : "#";
              let linkColor = item.color;
              if (linkColor) {
                nestedLink.setAttribute("style", `color:${linkColor}`);
              }
              nestedLi.appendChild(nestedLink);
              categoryUl.appendChild(nestedLi);
            });
            categoryLi.appendChild(categoryUl);
            nestedUl.appendChild(categoryLi);
          }
        });
        mainDiv.appendChild(nestedUl);

        li.appendChild(mainDiv);
      }

      // Append the list item to the unordered list
      menuWrapper.appendChild(li);
    });
    let fullMenu = document.getElementById("nosto-menu-desktop");
    if (fullMenu) {
      fullMenu.innerHTML = "";
      fullMenu.appendChild(menuWrapper);
    }
  },
  refreshProducts: function () {
    let mobileForm = document.getElementById("FacetFiltersFormMobile2");
    let textinputs = mobileForm
      ? mobileForm.querySelectorAll("input[type=checkbox]")
      : "";
    let checked = [].filter.call(textinputs, function (el) {
      return el.checked;
    });
    let jsonFilter = [];
    let jsonFilterValid = [];
    let allFilters = {};
    checked.forEach((input) => {
      let name = input.getAttribute("name");
      let value = input.getAttribute("value");
      if (!allFilters[name]) {
        allFilters[name] = [];
      }
      allFilters[name].push(value);
    });
    let idx = 0;
    let filtersCt = Object.keys(allFilters).length;
    for (var fieldName in allFilters) {
      idx++;
      if (allFilters.hasOwnProperty(fieldName)) {
        let values = JSON.stringify(allFilters[fieldName]);
        let json = `{ field: "${fieldName}", value: ${values} }`;
        let jsonValid = `{ "field": "${fieldName}", "value": ${values} }`;
        if (idx < filtersCt) {
          jsonValid += ",";
        }
        jsonFilter += json;
        jsonFilterValid += jsonValid;
      }
    }
    let currentFilter = localStorage.getItem("current-product-filter");
    let storeFilter = JSON.stringify(jsonFilter);
    if (storeFilter != currentFilter) {
      localStorage.setItem("current-product-filter", storeFilter);
      jsonFilter = `[${jsonFilter}]`;
      jsonFilterValid = `[${jsonFilterValid}]`;
      this.filterNostoProducts(null, null, null, null, jsonFilter, jsonFilterValid);
    }
  },
  createMobileNav: function (json) {
    let mobileDiv = document.getElementById("mobile-menu-drawer--inner");
    if (mobileDiv) {
      mobileDiv.innerHTML = "";
      let menuHTML = "";
      json.nav_categories.map((item, idx) => {
        let categories = item.categories_mobile;
        if (!categories || categories.length == 0) {
          categories = item.categories;
        }
        let detailsHTML = this.createBackLink(item.name);
        if (categories && categories.length > 0) {
          categories.map((category) => {
            if (category.type == "navigation_promos") {
              let promoTitle = category.promo_title;
              let promoImage = category.promo_image;
              let promoSubTitle = category.promo_subtitle
                ? category.promo_subtitle
                : "";
              let promoLink = category.promo_url ? category.promo_url : "#";
              if (promoTitle && promoImage) {
                detailsHTML += `<li>
                        <div class="mega-menu-promotion">
                          <div class="mega-menu-promotion--image">
                            <img class="no-blur lazyautosizes lazyloaded" width="350" height="220" data-sizes="auto" src="${promoImage}" data-srcset="${promoImage}" fetchpriority="low" alt="" style="object-position: 50.0% 50.0%;" sizes="189px" srcset="${promoImage}">
                          </div>
                          <div class="mega-menu-promotion--content"><span class="h6">${promoTitle}</span><p>${promoSubTitle}</p></div><a href="${promoLink}" class="mega-menu-promotion--link"></a></div>
                      </li>`;
              }
            } else {
              let links = category.items;
              let linksHTML = this.createBackLink(category.title);
              if (links && links.length > 0) {
                links.map((link) => {
                  linksHTML += this.createLink(link);
                });
                let details = this.createDetails(category.title, linksHTML);
                detailsHTML += details;
              } else {
                if (category.title) {
                  detailsHTML += `<li>
               <a href="${window.Shopify.routes.root.slice(0, -1) + category.url
                    }" title="${category.title}" class="${category.type}" role="menuitem">${category.title} </a>
               </li>`;
                }
              }
            }

          });
          menuHTML += this.createDetails(item.name, detailsHTML);
        } else {
          menuHTML += this.createLink(item);
        }
      });
      mobileDiv.innerHTML = `
    <ul class="mobile-menu">
      ${menuHTML}
    </ul>`;
      let themeHeader = document.querySelector("theme-header");
      themeHeader.addSummaryListener();
    }

  },
  createDetails: function (title, linksHTML) {
    let detailsHTML = `<li>
        <details class="link-container submenu-open">
          <summary class="parent-link">
          ${title}
            <span class="link-forward">
              <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.999999 13L7 7L1 1" stroke="var(--color-header-links, --color-accent)" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
            </span>
          </summary>
          <ul class="sub-menu">
            ${linksHTML}
          </ul>
        </details>
      </li>`;
    return detailsHTML;
  },
  createBackLink: function (title) {
    let link = `
      <li class="parent-link-back">
        <button class="parent-link-back--button">
          <span>
            <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 9L1 5L5 1" stroke="var(--color-header-links, --color-accent)" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
          </span> 
          ${title}
        </button>
      </li>`;
    return link;
  },
  createLink: function (link) {
    let linkColor = "";
    if (link.color) {
      linkColor = ` style="color:${link.color}"`;
    }
    let linkHTML = `
      <li>
      <a${linkColor} href="${window.Shopify.routes.root.slice(0, -1) + link.url
      }" title="${link.name}" role="menuitem">${link.name} </a>
      </li>`;
    return linkHTML;
  },
  convertPrice: function (price) {
    let decimalNumber = price / 100;

    // Format the decimal number to two decimal places
    let formattedNumber = decimalNumber.toFixed(2);

    return ShopifyDollar.format(formattedNumber);
  },
  customizeImageSize: function (image) {
    const image_src_append = "_610x_crop_center";
    imageArr = image.split(".jpg");
    let newImage = imageArr[0] + image_src_append + ".jpg";
    return newImage;
  },
  removeCookie: function (cookie, domain, removeWww) {
    if (removeWww) {
      const wwwPrefix = "www.";
      domain = domain.replace(wwwPrefix, "");
    }
    // remove cookie by expiring it
    document.cookie = cookie + "=; domain=" + domain + "; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  },
  getCookie: function (cookie) {
    let name = cookie + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  },
  handleNostoDoNotTrack: function (domain) {
    const oneTrustCookie = custom.getCookie("OptanonConsent");
    const preferenceCategoryGranted = "C0003:1";
    const consentGranted = oneTrustCookie.includes(preferenceCategoryGranted);
    nostojs(api => api.visit.setDoNotTrack(!consentGranted));
    nostojs(api => api.setAutoLoad(false));
    document.addEventListener("visitorConsentCollected", (event) => {
      if (event.detail.preferencesAllowed == true) {
        nostojs(api => api.visit.setDoNotTrack(false));
      } else {
        nostojs(api => api.visit.setDoNotTrack(true));
        custom.removeCookie("2c.cId", domain, true);
      }
    });
  },
  handleNostoProductResponse: function (
    placementId,
    sectionId,
    max_products,
    doCarousel,
    languageCode,
    discountPlacement,
    response
  ) {
    if (response.recommendations.hasOwnProperty(placementId)) {
      let nosto_placement = response.recommendations[placementId];
      if (nosto_placement) {
        //Check if the response is a string before parsing
        if (typeof nosto_placement === "string") {
          nosto_placement = JSON.parse(nosto_placement);
        }
        
        let nostoArr = nosto_placement.products;
        let slotId = nosto_placement.params ? nosto_placement.params.nosto : '';
        let header = nosto_placement.title;
        let parentElem = document.getElementById('shopify-section-' + sectionId);
        if (parentElem) {
          let headerElem = parentElem.querySelector('.mo-heading');
          if (headerElem) {
            headerElem.innerHTML = header;
          }
        }
        nostoArray = nostoArr.slice(0, max_products);
        let index = 0;
        nostoArray.forEach((product, idx) => {
          let productUrlSplit = product.url.split("/");
          const handleFiltered = productUrlSplit[productUrlSplit.length - 1];
          if (handleFiltered) {
            let ulProducts = document.querySelector(`.products_${sectionId}`);
            if (doCarousel) {
              ulProducts = document.querySelector(
                `.products_${sectionId} .flickity-slider`
              );
            }

            if (ulProducts) {
              const placeholders = ulProducts.querySelectorAll(
                ".product-placeholder"
              );
              placeholders.forEach((placeholder) => {
                placeholder.remove();
              });
              const hiddendivs = ulProducts.querySelectorAll("div");
              hiddendivs.forEach((div) => {
                if (!div.classList.contains("product")) {
                  div.remove();
                }
              });

              let productLi = document.createElement("div");
              let percentNum = idx * 100;
              if (doCarousel) {
                productLi.setAttribute(
                  "style",
                  `position: absolute; left: 0px; transform: translateX(${percentNum}%);`
                );
                productLi.setAttribute(
                  "class",
                  `small-6 medium-6 large-3 columns carousel__slide product product-${sectionId}-${handleFiltered}`
                );
              } else {
                productLi.setAttribute(
                  "class",
                  "small-6 medium-6 large-3 columns product  product-${sectionId}-${handleFiltered}"
                );
              }
              ulProducts.appendChild(productLi);
              productCardElems.getPdpItem(handleFiltered, false, sectionId, false, slotId);
            }
          }
        });
        setTimeout(() => {
          custom.updateNostoSlideshow();
        }, 500);
      }
    } else {
      this.hide("shopify-section-" + sectionId);
    }
  },
  callNostoNavigation: function () {
    let navigation_test = custom.getAttribute("navigation_test");
    if (navigation_test) {
      //Show default navigation if nosto is turned off
      custom.createNavigation(navigation_test);
    } else {
      setTimeout(function () {
        let fullMenuElem = document.getElementById("nosto-menu-desktop");
        if (fullMenuElem) {
          if (fullMenuElem.innerHTML == "") {
            custom.createNavigation("default");
          }
        }
      }, 500);
      nostojs((api) => {
        api
          .defaultSession()
          .viewFrontPage()
          .setPlacements(["navigation-menu"])
          .load()
          .then((data) => {
            if (custom.getAttribute("debugnav")) {
              let now = Date.now();
              console.warn("Navigation Load Time: ", now - before + " ms");
              console.log("Response:", data);
            }
            let menuKeyStr = "default";
            if (
              data.recommendations["navigation-menu"] &&
              data.recommendations["navigation-menu"] != "undefined"
            ) {
              let menu = data.recommendations["navigation-menu"];
              if (menu.html) {
                menuKeyStr = menu.html;
              } else {
                menuKeyStr = menu;
              }
            } else {
              menuKeyStr = "default";
            }

            if (menuKey && menuKeyStr != "undefined") {
              sessionStorage.setItem(menuKey, menuKeyStr); //Update existing menu storage key
            }
            if (!currentMenuStorage) {
              custom.createNavigation(menuKeyStr);
            }
          });
      });
    }
  },
  validateNostoSection: function (sectionId, doCarousel) {
    //If Nosto hasent set the slider products, hide the slider
    let ulProducts = document.querySelector(`.products_${sectionId}`);
    if (doCarousel) {
      ulProducts = ulProducts.querySelector('.flickity-slider');
    }
    let placeholder = ulProducts.querySelector('.product-placeholder');
    if (placeholder) {
      this.hide("shopify-section-" + sectionId);
    }
  },
  callNostoProducts: function (
    doCarousel,
    placementId,
    productId,
    sectionId,
    productLimit,
    languageCode,
    discountPlacement
  ) {
    setTimeout(() => {
      custom.validateNostoSection(sectionId, doCarousel);
    }, 8000);
    let parentElem = document.getElementById('shopify-section-' + sectionId);
    if (parentElem) {
      let headerElem = parentElem.querySelector('.mo-heading');
      if (headerElem) {
        headerElem.innerHTML = "";
      }
    }

    if (custom.getAttribute('from_key') == 'true') {
      custom.isCategoryPage = false;
      custom.isSearchPage = true;
    }
    if (custom.isProductPage) {
      if (custom.getAttribute("debugrec")) {
        console.log("recommendation request", {
          placementId: placementId,
          productId: productId,
          sectionId: sectionId,
          productLimit: productLimit,
          languageCode: languageCode,
          discountPlacement: discountPlacement,
          viewPage: 'Product'
        });
      }
      nostojs((api) => {
        api
          .defaultSession()
          .viewProduct(productId)
          .setPlacements([placementId])
          .load()
          .then((response) => {
            if (custom.getAttribute("debugrec")) {
              console.log("recommendation response", response);
            }
            if (response) {
              custom.handleNostoProductResponse(
                placementId,
                sectionId,
                productLimit,
                doCarousel,
                languageCode,
                discountPlacement,
                response
              );
            }
          });
      });
    } else if (custom.isCategoryPage) {
      if (custom.getAttribute("debugrec")) {
        console.log("recommendation request", {
          placementId: placementId,
          productId: productId,
          sectionId: sectionId,
          productLimit: productLimit,
          languageCode: languageCode,
          discountPlacement: discountPlacement,
          viewPage: 'Collection Page'
        });
      }
      nostojs((api) => {
        api
          .defaultSession()
          .viewCategory(collectionId)
          .setPlacements([placementId])
          .load()
          .then((response) => {
            if (custom.getAttribute("debugrec")) {
              console.log("recommendation response", response);
            }
            if (response) {
              custom.handleNostoProductResponse(
                placementId,
                sectionId,
                productLimit,
                doCarousel,
                languageCode,
                discountPlacement,
                response
              );
            }
          });
      });
    } else if (custom.isSearchPage) {
      if (custom.getAttribute("debugrec")) {
        console.log("recommendation request", {
          placementId: placementId,
          productId: productId,
          sectionId: sectionId,
          productLimit: productLimit,
          languageCode: languageCode,
          discountPlacement: discountPlacement,
          viewPage: 'Search Page'
        });
      }
      nostojs((api) => {
        api
          .defaultSession()
          .viewSearch(searchTerm)
          .setPlacements([placementId])
          .load()
          .then((response) => {
            if (custom.getAttribute("debugrec")) {
              console.log("recommendation response", response);
            }
            if (response) {
              custom.handleNostoProductResponse(
                placementId,
                sectionId,
                productLimit,
                doCarousel,
                languageCode,
                discountPlacement,
                response
              );
            }
          });
      });
    } else if (custom.isHomePage) {
      if (custom.getAttribute("debugrec")) {
        console.log("recommendation request", {
          placementId: placementId,
          productId: productId,
          sectionId: sectionId,
          productLimit: productLimit,
          languageCode: languageCode,
          discountPlacement: discountPlacement,
          viewPage: 'Front Page'
        });
      }
      nostojs((api) => {
        api
          .defaultSession()
          .viewFrontPage()
          .setPlacements([placementId])
          .load()
          .then((response) => {
            if (custom.getAttribute("debugrec")) {
              console.log("recommendation response", response);
            }
            if (response) {
              custom.handleNostoProductResponse(
                placementId,
                sectionId,
                productLimit,
                doCarousel,
                languageCode,
                discountPlacement,
                response
              );
            }
          });
      });
    } else if (custom.isCartPage) {
      if (custom.getAttribute("debugrec")) {
        console.log("recommendation request", {
          placementId: placementId,
          productId: productId,
          sectionId: sectionId,
          productLimit: productLimit,
          languageCode: languageCode,
          discountPlacement: discountPlacement,
          viewPage: 'Cart Page'
        });
      }
      nostojs((api) => {
        api
          .defaultSession()
          .viewCart()
          .setPlacements([placementId])
          .load()
          .then((response) => {
            if (custom.getAttribute("debugrec")) {
              console.log("recommendation response", response);
            }
            if (response) {
              custom.handleNostoProductResponse(
                placementId,
                sectionId,
                productLimit,
                doCarousel,
                languageCode,
                discountPlacement,
                response
              );
            }
          });
      });
    } else {
      if (custom.getAttribute("debugrec")) {
        console.log("recommendation request", {
          placementId: placementId,
          productId: productId,
          sectionId: sectionId,
          productLimit: productLimit,
          languageCode: languageCode,
          discountPlacement: discountPlacement,
          viewPage: 'Front Page - Else Condition'
        });
      }
      nostojs((api) => {
        api
          .defaultSession()
          .viewFrontPage()
          .setPlacements([placementId])
          .load()
          .then((response) => {
            if (custom.getAttribute("debugrec")) {
              console.log("recommendation response", response);
            }
            if (response) {
              custom.handleNostoProductResponse(
                placementId,
                sectionId,
                productLimit,
                doCarousel,
                languageCode,
                discountPlacement,
                response
              );
            }
          });
      });
    }
  },
  callNostoSection: function (placementId, sectionId, type) {
    if (!type) {
      return;
    }

    this.hideVisible("shopify-section-" + sectionId);
    let nosto_debug = custom.getAttribute("nosto_debug");
    if (nosto_debug) {
      let json = { handle: nosto_debug };
      custom.handleNostoSectionResponse(json, sectionId, type);
    } else if (custom.nostoApiKey != "") {
      nostojs((api) => {
        api
          .defaultSession()
          .setResponseMode("HTML")
          .viewFrontPage()
          .setPlacements([placementId])
          .load()
          .then((response) => {

            if (response.recommendations.hasOwnProperty(placementId)) {

              let json = JSON.parse(response.recommendations[placementId]);
              custom.handleNostoSectionResponse(json, sectionId, type);
            } else {
              this.hide("shopify-section-" + sectionId);
            }
          })
          .catch((error) => {
            console.error("Error calling Nosto:", error);
          });
      });
    } else {
      custom.hide("shopify-section-" + sectionId);
    }
  },
  handleNostoSectionResponse: function (json, sectionId, type) {
    custom.hideVisible("shopify-section-" + sectionId);

    let handle = json.handle;
    if (!handle) {
      return false;
    }
    if (type == 'collection_list_nosto') {
      this.callStorefrontAPI(handle, sectionId, type);
    } else {
      this.callMetaobjectAPI(handle, sectionId, type);
    }
  },
  callMetaobjectAPI: function (handle, sectionId, type) {
    let apiPath = type;
    let setDate = custom.getAttribute('SETDATE');
    if (setDate) {
      const date = new Date(setDate); // Create a new Date object representing the current date and time
      const timestamp = date.getTime(); // Get the timestamp in milliseconds
      handle += '_' + timestamp.toString().slice(0, -3);
    }
    let metaobjectUrl = productCardElems.parsePageUrl(`metaobject-api/${apiPath}*${handle}`);
    fetch(metaobjectUrl)
      .then((response) => {
        return response.text();
      })
      .then((data) => {
        let json = "";
        if (data) {
          json = JSON.parse(data);
        }
        custom.handleMetaObjectReponse(json, 'shopify-section-' + sectionId, type)
      });
  },
  handleImageWithText: function (metaobject, collectionSectionid) {
    let heading = document
      .getElementById(collectionSectionid)
      .querySelector(".image-with-text--content--inner").querySelector('h1')
    let subheading = document
      .getElementById(collectionSectionid)
      .querySelector(".subheading");
    let text = document
      .getElementById(collectionSectionid)
      .querySelector(".image-with-text--content--inner")
      .querySelector('.rte')
      .querySelector('p')
    let desktop_image = document
      .getElementById(collectionSectionid)
      .querySelector(".image-with-text--desktop");
    let mobile_image = document
      .getElementById(collectionSectionid)
      .querySelector(".image-with-text--mobile");
    if (heading)
      heading.innerHTML = metaobject.heading;
    desktop_image.setAttribute('src', metaobject.desktop_image);
    if (subheading)
      subheading.innerHTML = metaobject.sub_heading;
    text.innerHTML = metaobject.text;
    let buttons;
    if (metaobject.buttons)
      buttons = metaobject.buttons.slice(0, 7);
    let buttonsInner = document
      .getElementById(collectionSectionid).querySelector('.image-with-text--content--inner');
    buttonsInner.querySelectorAll('.button').forEach(e => e.remove());
    if (buttons) {
      buttons.forEach((btn) => {
        let button_name = btn.button_name;

        let button_url = btn.url;
        let buttonStyle = btn.style;
        let create_button = `<a class="button ${buttonStyle}" href="${button_url}" role="button" title="${button_name}">${button_name}</a>`
        buttonsInner.innerHTML += create_button;
      });
    }
    this.showVisible(collectionSectionid);
  },
  handleGallery: function (metaobject, collectionSectionid) {

    let column_container = document
      .getElementById(collectionSectionid)
      .querySelector('.row').querySelector('div').querySelector('theme-gallery').querySelector('.gallery--inner');

    let columns = column_container.querySelectorAll('.gallery--item');
    columns.forEach((column, idx) => {
      let figure = column.querySelector('figure');
      if (figure) {
        let column = metaobject['columns'][idx];
        let contentContainer = figure.querySelector('.gallery--item-content').querySelector('div');
        let desktop_container = figure.querySelector('.gallery_desktop_image');
        let video_container = figure.querySelector('.gallery__video-hosted');
        let column_image = "";
        if (desktop_container) {
          column_image = desktop_container.querySelector("img");
        }
        if (video_container) {
          column_video = video_container.querySelector('video');
        }
        let mobile_container = figure.querySelector('.gallery_mobile_image');
        let column_mobile_image = "";
        if (mobile_container) {
          column_mobile_image = mobile_container.querySelector("img");
        }

        let column_header = contentContainer.querySelector('h2');

        let column_description;
        if (contentContainer.querySelector('.description-size--medium')) {
          column_description = contentContainer.querySelector('.description-size--medium').querySelector('p');
        }
        let column_subheader = contentContainer.querySelector('.subheading');

        let buttons = contentContainer.querySelectorAll('.button');
        if (column) {
          let api_buttons = column['buttons'];
          api_buttons.forEach((button, btnidx) => {
            let btn_text = button['text'];
            if (btn_text) {
              let btn_link = button['link'];
              let btn_style = button['style'];
              if (buttons[btnidx]) {
                buttons[btnidx].innerHTML = btn_text;
                buttons[btnidx].setAttribute('class', 'button ' + btn_style);
                buttons[btnidx].setAttribute('href', btn_link);
              }
            } else {
              if (buttons[btnidx]) {
                buttons[btnidx].style.display = 'none';
              }
            }
          });

          let image_source = column['image'];
          let image_mobile_source = column['image_mobile'];
          let video_source = column['video'];
          let header_text = column['header'];
          let subheader_text = column['sub_header'];
          let description_text = column['description'];
          if (!header_text) {
            header_text = "";
          }
          if (!subheader_text) {
            subheader_text = "";
          }
          if (column_header) {
            column_header.innerHTML = header_text;
          }
          if (column_subheader) {
            column_subheader.innerHTML = `<p>${subheader_text}</p>`;
          }
          if (column_description) {
            column_description.innerHTML = `<p>${description_text}</p>`;
          }
          if (column_image) {
            column_image.setAttribute('src', image_source);
          }
          if (column_mobile_image) {
            column_mobile_image.setAttribute('src', image_mobile_source);
          }
        }
      }
    });


    this.showVisible(collectionSectionid);
  },
  handleMulticolumn: function (metaobject, collectionSectionid) {
    let heading = document
      .getElementById(collectionSectionid)
      .querySelector(".section-header--title");
    let subheading = document
      .getElementById(collectionSectionid)
      .querySelector(".section-header--description");
    let column_container = document
      .getElementById(collectionSectionid)
      .querySelector(".multicolumn__inner").querySelector('.row');

    let columns = column_container.querySelectorAll('.multicolumn__column');

    columns.forEach((column, idx) => {
      let column_image;
      if (column.querySelector(".multicolumn__image--inner"))
        column_image = column.querySelector(".multicolumn__image--inner").querySelector("img");
      let column_header = column.querySelector('.multicolumn__container').querySelector('h4');
      let column_subheader = column.querySelector('.multicolumn__container').querySelector('.rte');
      let image_source = metaobject['image_' + (idx + 1)];
      let header_text = metaobject['column_' + (idx + 1) + '_header'];
      let subheader_text = metaobject['column_' + (idx + 1) + '_sub_header'];
      let link = metaobject['column_' + (idx + 1) + '_link'];
      if (!header_text) {
        header_text = "";
      }
      if (!subheader_text) {
        subheader_text = "";
      }
      if (column_header) {
        column_header.innerHTML = header_text;
      }
      if (column_subheader) {
        column_subheader.innerHTML = `<p>${subheader_text}</p>`;
      }
      if (link) {
        if (column.querySelector(".multicolumn__image--inner"))
          column.querySelector(".multicolumn__image--inner").innerHTML = `<a href="${link}"><img class=" retina_size" src="${image_source}"></a>`
      } else {
        if (column_image)
          column_image.setAttribute('src', image_source);
      }


    });
    if (heading) {
      heading.innerHTML = metaobject.heading;
    }
    if (subheading) {
      subheading.innerHTML = `<p>${metaobject.sub_heading}</p>`
    }
    this.showVisible(collectionSectionid);
  },
  handleImageWithTextOverlay: function (metaobject, collectionSectionid) {
    let heading = document
      .getElementById(collectionSectionid)
      .querySelector(".mo-heading");
    let subheading = document
      .getElementById(collectionSectionid)
      .querySelector(".mo-subheading");
    let text = document
      .getElementById(collectionSectionid)
      .querySelector(".mo-description").querySelector('p');
    let desktop_image = document
      .getElementById(collectionSectionid)
      .querySelector(".image-with-text-overlay--desktop");
    let mobile_image = document
      .getElementById(collectionSectionid)
      .querySelector(".image-with-text-overlay--mobile");
    if (desktop_image && metaobject.desktop_image) {
      desktop_image.setAttribute('src', metaobject.desktop_image);
    }
    if (mobile_image && metaobject.mobile_image) {
      mobile_image.setAttribute('src', metaobject.mobile_image);
    }

    if (subheading)
      subheading.innerHTML = metaobject.sub_heading;
    if (heading)
      heading.innerHTML = metaobject.heading;
    if (text)
      text.innerHTML = `<p>${metaobject.text}</p>`

    let buttons = metaobject.buttons.slice(0, 7);
    let buttonsInner = document.getElementById(collectionSectionid).querySelector('.image-with-text-overlay--content-inner');
    if (buttonsInner) {
      buttonsInner.querySelectorAll('.button').forEach(e => e.remove());

      buttons.forEach((btn) => {
        let button_name = btn.button_name;
        let button_url = btn.url;
        let buttonStyle = btn.style;
        let create_button = `<a class="button ${buttonStyle}" href="${button_url}" role="button" title="${button_name}">${button_name}</a>`
        buttonsInner.innerHTML += create_button;
      });
    }
    this.showVisible(collectionSectionid);
  },
  handleMetaObjectReponse: function (metaobject, collectionSectionid, type) {
    if (!metaobject[type] || !Array.isArray(metaobject[type]) || !metaobject[type][0] || !metaobject[type][0].data) {
      document.getElementById(collectionSectionid).style.display = "none";
      return false;
    }
    let metaobjectData = metaobject[type][0].data;
    if (!custom.handleNostoDefault(metaobject, collectionSectionid, type)) {
      return false;
    }
    if (type == 'image_with_text') {
      this.handleImageWithText(metaobjectData, collectionSectionid);
    } else if (type == 'image_with_text_overlay') {
      this.handleImageWithTextOverlay(metaobjectData, collectionSectionid);
    } else if (type == 'multicolumn_nosto') {
      this.handleMulticolumn(metaobjectData, collectionSectionid);
    } else if (type == 'gallery') {
      this.handleGallery(metaobjectData, collectionSectionid);
    } else if (type == 'slideshow') {
      this.handleSlideshow(metaobjectData, collectionSectionid);
    } else if (type == 'scrolling_text') {
      this.handleScrollingText(metaobjectData, collectionSectionid);
    } else if (type == 'rich_text') {
      this.handleRichText(metaobjectData, collectionSectionid);
    } else if (type == 'custom_collection_list') {
      this.handleCustomCollectionList(metaobjectData, collectionSectionid);
    } else if (type == 'featured-collection-promo') {
      this.handleFeaturedCollectionPromo(metaobjectData, collectionSectionid);
    } else if (type == 'announcement_bar') {
      this.handleAnnouncementBar(metaobjectData, collectionSectionid);
    }
  },
  loadSizeChartPopupContent: function (handle) {
    productCardElems.getPageItem(handle, "product-popup-modal__content-info");
  },
  createButtonFilters: function (inputStr, dropdownId, isSticky, isQuickView, isPopover, productId, disabledValues) {
    // Parse the input string to create a mapping of numbers to letters
    const items = inputStr.split(',').filter(Boolean); // Remove empty string at the end
    const numberToLettersMap = {};
    items.forEach(item => {
      const number = item.match(/\d+/) ? item.match(/\d+/)[0] : "";
      const letter = item.match(/[A-Za-z]+/) ? item.match(/[A-Za-z]+/)[0] : item.match(/[A-Za-z]+/);

      if (!numberToLettersMap[number]) {
        numberToLettersMap[number] = [];
      }

      // Only add the letter if it's not already in the array to avoid duplicates
      if (!numberToLettersMap[number].includes(letter)) {
        numberToLettersMap[number].push(letter);
      }
    });

    // Get the button containers
    let appendId = '';
    if (isSticky) {
      appendId = '_sticky';
    } else if (isQuickView) {
      appendId = '_quickview'
    } else if (isPopover) {
      appendId = '-' + dropdownId;
      document.querySelector('.hover-size-container').style.display = 'none';
    }
    const numberButtonsContainer = document.getElementById('numberButtons' + appendId);

    const letterButtonsContainer = document.getElementById('letterButtons' + appendId);
    if (!numberButtonsContainer || !letterButtonsContainer) {
      return false;
    }
    // Clear existing buttons
    numberButtonsContainer.innerHTML = '';
    letterButtonsContainer.innerHTML = '';

    let currentSelectedNumber = null;
    let defaultNumberSet = false;

    // Function to handle button click and add 'active' class
    function handleButtonClick(button, container) {
      let cartElem = document.getElementById('AddToCart');
      if (container.getAttribute('id') == 'numberButtons') {
        let outOfStock = document.querySelector('.out-of-stock');
        if (outOfStock) {
          setTimeout(() => {
            outOfStock.style.display = 'none';
          }, 500);
        }
        if (cartElem) {
          cartElem.style.display = 'none';
          document.getElementById('enterSizeBtn').style.display = 'block';
          let klaviyoElem = document.querySelector('.klaviyo-bis-trigger');
          if (klaviyoElem) {
            document.querySelector('.klaviyo-bis-trigger').style.display = 'none';
          }
        }
      } else if (cartElem) {
        cartElem.style.display = 'block';
        document.getElementById('enterSizeBtn').style.display = 'none';
      }
      // Remove 'active' class from all buttons in the container
      const buttons = container.getElementsByClassName('variant-button');
      for (let btn of buttons) {
        btn.classList.remove('active');
      }

      // Add 'active' class to the clicked button
      button.classList.add('active');
    }

    // Function to update the letter buttons based on the selected number
    function updateLetterButtons(selectedNumber) {
      const availableLetters = numberToLettersMap[selectedNumber];

      // Clear the letter buttons container
      letterButtonsContainer.innerHTML = '';

      // Create and append letter buttons
      availableLetters.forEach(letter => {
        const button = document.createElement('button');
        button.className = 'variant-button';
        button.textContent = letter;
        button.id = 'btn_' + selectedNumber + '_' + letter + '_' + appendId;

        if (isDisabledInDropdown(selectedNumber, letter, dropdownId, isPopover)) {
          button.classList.add('no-quantity');
          if (isPopover) {
            button.disabled = true;
          }
        }
        button.onclick = () => {
          handleButtonClick(button, letterButtonsContainer);
          if (isPopover) {
            let selectedSize = document.getElementById('variant-' + dropdownId + '-' + selectedNumber + letter);
            selectedSize.click();
          }
          else if (currentSelectedNumber && !button.disabled) {
            custom.updateMainDropdown(currentSelectedNumber + letter, dropdownId);
          }
        };

        letterButtonsContainer.appendChild(button);

        // If this is the first non-disabled letter, set it as the default
        if (!button.disabled && !defaultNumberSet) {
          handleButtonClick(button, letterButtonsContainer);
          if (!isPopover) {
            custom.updateMainDropdown(selectedNumber + letter, dropdownId);
          }
          defaultNumberSet = true;
        }


      });


    }

    // Check if an option is disabled in the dropdown
    function isDisabledInDropdown(number, letter, dropdownId, isPopover) {
      let value = number + letter;
      if (isPopover) {
        const divElem = document.getElementById('variant-' + dropdownId + '-' + value);
        if (divElem && divElem.classList.contains('no-quantity')) {
          return true;
        }
      } else {
        const dropdown = document.getElementById(dropdownId);
        const options = dropdown.options;
        for (let i = 0; i < options.length; i++) {
          if (options[i].value === value && options[i].disabled) {
            return true;
          }
        }
      }

      return false;
    }



    // Create and append number buttons
    let btnsIdx = 0;
    let firstValidLetter = '';
    let firstValidNumber = '';
    let firstLetter = '';
    let firstNumber = '';
    Object.keys(numberToLettersMap).forEach(number => {
      const button = document.createElement('button');
      button.className = 'variant-button';
      button.textContent = number;
      button.id = 'btn_' + number + '_' + appendId;
      const availableLetters = numberToLettersMap[number];
      let hasValidLetter = false;

      availableLetters.forEach(letter => {
        if (!firstLetter) {
          firstLetter = letter;
          firstNumber = number;
        }
        if (!disabledValues || !disabledValues.includes(number + letter + ',')) {
          hasValidLetter = true;
          if (!firstValidLetter) {
            firstValidLetter = letter;
            firstValidNumber = number;
          }

        }
      });
      if (!hasValidLetter) {
        button.classList.add('no-quantity');
      }
      button.onclick = () => {
        handleButtonClick(button, numberButtonsContainer);
        updateLetterButtons(number);
        currentSelectedNumber = number;
      };
      numberButtonsContainer.appendChild(button);

      if (btnsIdx == Object.keys.length) {
        custom.selectDefaultButtons(dropdownId, appendId, isPopover);
      }
      btnsIdx++;

    });
    if (firstValidLetter && firstValidNumber) {
      setTimeout(() => {
        document.getElementById('btn_' + firstValidNumber + '_' + appendId).click();
        if (!isPopover) {
          document.getElementById('btn_' + firstValidNumber + "_" + firstValidLetter + '_' + appendId).click();
        }
      }, 500);
    } else if (!isPopover) {//If no products are available, select the first product to show notify me button
      setTimeout(() => {
        document.getElementById('btn_' + firstLetter + '_' + appendId).click();
        document.getElementById('btn_' + firstNumber + "_" + firstLetter + '_' + appendId).click();
      }, 500);
    }
  },
  updateMainDropdown: function (value, dropdownId) {
    // Set the value of the main dropdown
    const dropdown = document.getElementById(dropdownId);
    dropdown.value = value;

    ev = document.createEvent('Event');
    ev.initEvent('change', true, false);
    dropdown.dispatchEvent(ev);

    // Add your custom logic here
  },
  selectDefaultButtons: function (dropdownId, appendId, isPopover) {
    if (isPopover) {
      let buttonContainer = document.getElementById('numberButtons-' + dropdownId);
      let letterContainer = document.getElementById('letterButtons-' + dropdownId);
      if (buttonContainer) {
        let buttons = buttonContainer.querySelectorAll('.variant-button');
        buttons[0].click();
        for (let btn of letterContainer.querySelectorAll('.variant-button')) {
          btn.classList.remove('active');
        }
      }
      return;
    }
  },
  createButtonFiltersQuickView: function () {
    setTimeout(() => {
      if (document.getElementById('optionValues') && document.getElementById('disabledValues') && document.getElementById('dropdownId')) {
        let optionValues = document.getElementById('optionValues').value;
        let disabledValues = document.getElementById('disabledValues').value;
        let dropdownId = document.getElementById('dropdownId').value;
        custom.createButtonFilters(optionValues, dropdownId, false, true, false, null, disabledValues);
      }
    }, 500);

  },
  callStorefrontAPI: function (handle, sectionId, type) {
    let collectionSectionid = "shopify-section-" + sectionId;
    fetchMetaobjectByHandle(handle, type)
      .then((metaobject) => {
        if (metaobject == null) {
          custom.hide(collectionSectionid);
          return false;
        }
        if (type == "collection_list_nosto") {
          custom.handleCollectionList(metaobject, collectionSectionid);
        }
      })
      .catch((error) => {
        console.error("Error fetching metaobject:", error);
      });
  },
  handleNostoDefault: function (metaobject, collectionSectionid, type) {
    if (metaobject && metaobject[type] && metaobject[type].length == 0) {
      console.error(`${type} failed to get metaobject`)
      this.hide(collectionSectionid);
      return false;
    }
    return true;
  },
  handleCollectionList: function (metaobject, collectionSectionid) {
    let header = metaobject.header ? metaobject.header.value : "";
    let subtitle = metaobject.description
      ? metaobject.description.value
      : "";
    let collectionEdges = metaobject.collections.references.edges;

    let sectionContent = document.getElementById(collectionSectionid);
    if (sectionContent) {
      let allCards = sectionContent.querySelectorAll(".collection-card");
      allCards.forEach((card, idx) => {
        let cardContent = card.querySelector(".collection-card--content");
        let cardImage = card.querySelector(".collection-card--image");
        let cardAnchors = card.querySelectorAll(".collection-card--link");
        if (collectionEdges[idx]) {
          cardAnchors.forEach((link) => {
            let linkHandle = collectionEdges[idx].node.handle;
            link.setAttribute("href", `/collections/${linkHandle}`);
          });
          let title = collectionEdges[idx].node.title;
          let imageSrc = collectionEdges[idx].node.image.src;
          cardContent.querySelector("span").innerHTML = title;
          let placeholderImage =
            cardImage.querySelector(".thb-placeholder");
          let placeholderHTML = `
       <img src="${imageSrc}">
      `;
          placeholderImage.innerHTML = placeholderHTML;
        } else {
          card.style.display = "none";
        }
      });
      this.showVisible(collectionSectionid);
      document
        .getElementById(collectionSectionid)
        .querySelector(".section-header--title").innerHTML = header;
      document
        .getElementById(collectionSectionid)
        .querySelector(
          ".section-header--description"
        ).innerHTML = `<p>${subtitle}</p>`;
    }
  },
  handleScrollingText: function (metaobject, collectionSectionid) {
    //Add data checking here
    let bgImage = document.getElementById(collectionSectionid).querySelector('.scrolling-text');
    if (bgImage) {
      bgImage.style.backgroundImage = `url(${metaobject.background})`;
    }

    let scrollingInner = document.getElementById(collectionSectionid).querySelector('.scrolling-text--inner');
    if (scrollingInner) {

      scrollingInner.querySelectorAll('div').forEach((div) => {
        let items = div.querySelectorAll('.scrolling-text--item');
        items.forEach((item, idx) => {
          if (metaobject.links[idx]) {
            item.querySelector('.mo-content').innerHTML = metaobject.links[idx].content;
            let scrollingImage = metaobject.links[idx].image;
            if (scrollingImage) {
              item.querySelector('.mo-scrolling-image').setAttribute('src', metaobject.links[idx].image);
            }
            let scrollingLink = metaobject.links[idx].link;
            if (item.querySelector('.mo-scrolling-link')) {
              if (scrollingLink) {
                item.querySelector('.mo-scrolling-link').setAttribute('href', metaobject.links[idx].link);
              } else {
                item.querySelector('.mo-scrolling-link').removeAttribute('href');
              }
            }
          }
        });
      })
    }
    this.show(collectionSectionid);
    this.showVisible(collectionSectionid);
  },
  handleRichText: function (metaobject, collectionSectionid) {
    custom.renderTextElement(collectionSectionid, '.mo-heading', metaobject.heading);
    custom.renderTextElement(collectionSectionid, '.mo-text', metaobject.text);
    custom.renderButton(collectionSectionid, '.mo-button', metaobject.button_link, metaobject.button_label);
    this.show(collectionSectionid);
    this.showVisible(collectionSectionid);
  },
  handleCustomCollectionList: function (metaobject, collectionSectionid) {
    //Add data checking here
    let desktopSlides = document.getElementById(collectionSectionid).querySelector('.mo-desktop-slide').querySelectorAll('.collection-card')
    desktopSlides.forEach((slide, idx) => {
      custom.handleCustomCollectionSlide(metaobject, slide, idx);
    });

    let mobileSlides = document.getElementById(collectionSectionid).querySelector('.mo-mobile-slide').querySelectorAll('.collection-card')
    mobileSlides.forEach((slide, idx) => {
      custom.handleCustomCollectionSlide(metaobject, slide, idx);
    });
    this.show(collectionSectionid);
    this.showVisible(collectionSectionid);
  },
  handleCustomCollectionSlide: function (metaobject, slide, idx) {
    let imageSrc = metaobject[idx].image;
    if (slide.querySelector('.mo-image')) {
      slide.querySelector('.mo-image').setAttribute(
        "src",
        imageSrc
      );
    }
    let link = metaobject[idx].url;
    if (link) {
      let buttonLabel = metaobject[idx].button_label;
      if (slide.querySelector('.collection-link')) {
        slide.querySelector('.collection-link').setAttribute('href', link);
      }
      if (slide.querySelector('.mo-link')) {
        slide.querySelector('.mo-link').setAttribute('href', link);
        if (buttonLabel) {
          slide.querySelector('.mo-link').innerHTML = buttonLabel;
        } else {
          slide.querySelector('.mo-link').style.display = 'none';
        }
      }
    }
    if (slide.querySelector('.mo-title')) {
      slide.querySelector('.mo-title').innerHTML = metaobject[idx].title;
    }
    if (slide.querySelector('.mo-description')) {
      slide.querySelector('.mo-description').innerHTML = metaobject[idx].description;
    }
  },
  handleFeaturedCollectionPromo: function (metaobject, collectionSectionid) {
    if (document.getElementById(collectionSectionid).querySelector('.collection-tabs__list')) {
      document.getElementById(collectionSectionid).querySelector('.collection-tabs__list').style.display = 'none';
    }
    custom.renderTextElement(collectionSectionid, '.mo-heading', metaobject.heading);
    custom.renderTextElement(collectionSectionid, '.mo-description', metaobject.description);
    custom.renderImageElement(collectionSectionid, '.mo-promo', metaobject.promotion_img_src);
    custom.renderTextElement(collectionSectionid, '.mo-promo-heading', metaobject.promotion_heading);
    custom.renderTextElement(collectionSectionid, '.mo-promo-description', metaobject.promotion_description);
    custom.renderButton(collectionSectionid, '.mo-promo-button', metaobject.promotion_btn_link, metaobject.promotion_btn_label);
    custom.updateLink(collectionSectionid, '.mo-promo-link', metaobject.promotion_img_link);
    const products = document.getElementById(collectionSectionid).querySelectorAll('.mo-product');
    products.forEach((product, idx) => {
      if (metaobject.products[idx]) {
        product.style.display = 'none';
        productCardElems.getPdpItem(metaobject.products[idx], false, product, true);
      }
    });

    this.show(collectionSectionid);
    this.showVisible(collectionSectionid);
  },
  handleAnnouncementBar: function (metaobject, collectionSectionid) {
    let collectionSectionElem = document.getElementById(collectionSectionid);
    if (collectionSectionElem) {
      let announcementItems = collectionSectionElem.querySelectorAll('.announcement-bar--item');
      if (announcementItems) {
        let metaobjectItems = metaobject.items;
        if (metaobjectItems.length == 2) {
          metaobjectItems = metaobjectItems.concat(metaobjectItems);
        }
        if (metaobjectItems.length == 3) {
          metaobjectItems.push(metaobject.items[1]);
        }
        announcementItems.forEach((item, idx) => {
          if (announcementItems[idx] && metaobjectItems[idx] && metaobjectItems[idx].content) {
            if (metaobjectItems[idx].link && announcementItems[idx].querySelector('a')) {
              announcementItems[idx].querySelector('a').setAttribute('href', metaobjectItems[idx].link);
              announcementItems[idx].querySelector('a').removeAttribute('target');
              announcementItems[idx].querySelector('a').innerHTML = metaobjectItems[idx].content;
            } else {
              announcementItems[idx].innerHTML = metaobjectItems[idx].content;
            }

          } else {
            announcementItems[idx].remove();
          }

        });
      }
      this.showVisible(collectionSectionid);
    }
  },
  updateLink: function (collectionSectionid, selector, link) {
    if (theme.settings.locale != "") {
      link = `/${theme.settings.locale}${link}`;
    }
    if (link) {
      let element = document.getElementById(collectionSectionid).querySelector(selector);
      if (element) {
        element.setAttribute('href', link);
      }
    }
  },
  renderButton: function (collectionSectionid, selector, link, label) {
    if (theme.settings.locale != "") {
      link = `/${theme.settings.locale}${link}`;
    }
    let element = document.getElementById(collectionSectionid).querySelector(selector);
    if (!label && element) {
      element.style.display = 'none';
      return;
    }
    if (element && link && label) {
      element.setAttribute('href', link);
      element.innerHTML = label;
    }
  },
  renderImageElement: function (collectionSectionid, selector, imageSrc) {
    let element = document.getElementById(collectionSectionid).querySelector(selector);
    if (element && element.querySelector('img')) {
      element.querySelector('img').setAttribute(
        "src",
        imageSrc
      );
    }
    else if (element && element.tagName.toLowerCase() === 'img') {
      element.setAttribute(
        "src",
        imageSrc
      );
    }
  },
  renderTextElement: function (collectionSectionid, selector, text) {
    let element = document.getElementById(collectionSectionid).querySelector(selector);
    if (element && element.querySelector('p')) {
      element.querySelector('p').innerHTML = text;
    } else if (element) {
      element.innerHTML = text;
    }
  },
  handleSlideshow: function (metaobject, collectionSectionid) {
    let slideContentSlides = document.getElementById(collectionSectionid).querySelectorAll('.slideshow__slide');
    let slideshow = metaobject;
    slideContentSlides.forEach((slide, idx) => {
      if (idx < custom.maxSlideshows) {
        if (slideshow.slides[idx]) {
          custom.handleSlide(slideshow.slides[idx], slide);
        } else {
          //remove slide if no data : TODO
        }

      }
    })

    slideContentSlides.forEach((slide, idx) => {
      let slide_buttons = slide.querySelectorAll(".button-overflow-container");
      if (slideshow.slides[idx] && slideshow.slides[idx].buttons) {
        slide_buttons.forEach((button, btnidx) => {
          custom.handleButtons(slideshow.slides[idx].buttons[btnidx], button);
        });
      }
    });
    let slideshowContent = document
      .getElementById(collectionSectionid)
      .querySelector(".slideshow__slide-content-link");

    if (
      metaobject.slidesURL &&
      metaobject.slidesURL.value &&
      metaobject.slidesURL.value != ""
    ) {
      slideshowContent.setAttribute("href", metaobject.slidesURL.value);
    }

    this.show(collectionSectionid);
    this.showVisible(collectionSectionid);
  },
  renderSlideImage: function (slideshowImageElem, slide, is_mobile) {
    let imageSrc;
    if (slide) {
      if (is_mobile) {
        imageSrc = slide['image_mobile'];
      } else {
        imageSrc = slide['image_desktop'];
      }
    }
    if (slideshowImageElem && imageSrc) {
      slideshowImageElem.setAttribute(
        "src",
        imageSrc
      );
    }
  },
  renderSlideText: function (slide, selector, txt) {
    if (slide.querySelectorAll(selector)) {
      slide.querySelectorAll(selector).forEach((elem) => {
        elem.innerHTML = txt;
      });
    }
  },
  handleSlide: function (slide_data, slide) {
    let slideshowImagesDesktop = slide.querySelectorAll(".mo-image-desktop");
    slideshowImagesDesktop.forEach((imageElem) => {
      custom.renderSlideImage(imageElem, slide_data);
    });

    let slideshowImagesMobile = slide.querySelectorAll(".mo-image-mobile");
    slideshowImagesMobile.forEach((imageElem) => {
      custom.renderSlideImage(imageElem, slide_data, true);
    });

    custom.renderSlideText(slide, '.nosto-slide-subheading', slide_data['subheading']);
    custom.renderSlideText(slide, '.nosto-slide-heading', slide_data['heading']);
    custom.renderSlideText(slide, '.nosto-slide-description', slide_data['description']);

  },
  handleButtons: function (button_values, button) {
    if (!button || !button_values) {
      button.style.display = 'none';
      return;
    }
    let buttonText = button_values['text'];
    let buttonurl = button_values['link']
    if (buttonurl != "") {
      button.querySelector(".button").setAttribute("href", buttonurl);
    }
    button.querySelector(".button").textContent = buttonText;
    if (!buttonText || buttonText == '') {
      button.style.display = 'none';
    }
  },
  getButtonUrl: function (collectionUrl, pageUrl, customUrl) {
    let buttonurl = collectionUrl ? collectionUrl : "";
    if (buttonurl != "") {
      return `/collections/${collectionUrl}`;
    } else if (!buttonurl != "" && pageUrl && pageUrl != "") {
      buttonurl = pageUrl;
    } else if (!buttonurl != "" && customUrl && customUrl != "") {
      buttonurl = customUrl;
    }
    return buttonurl;
  },
  hide: function (elem_id) {
    document.getElementById(elem_id).style.display = "none";
  },
  show: function (elem_id) {
    document.getElementById(elem_id).style.display = "block";
  },
  hideVisible: function (elem_id) {
    if (document.getElementById(elem_id)) {
      document.getElementById(elem_id).style.visibility = "hidden";
    }
  },
  showVisible: function (elem_id) {
    document.getElementById(elem_id).style.visibility = "";
    if (document.getElementById(elem_id).querySelector('.loader'))
      document.getElementById(elem_id).querySelector('.loader').style.visibility = '';
  },
  updateNostoSlideshow: function () {
    const slideshows = document.querySelectorAll(".nosto-slideshow");
    slideshows.forEach((slideshow) => {
      const image = slideshow.querySelector(".product-primary-image");
      const info = slideshow.querySelector(".product-card-info");
      if (image && info) {
        const imageHeight = image.clientHeight;
        const infoHeight = info.clientHeight;
        const newHeight = imageHeight + infoHeight + 50;
        const viewport = slideshow.querySelector(".flickity-viewport");
        if (viewport) {
          viewport.style.height = `${newHeight}px`;
        }
      }
    });
  },
  updateSearchTrending: function () {
    let placementId = theme.settings.nostoSearchPlacementId;
    nostojs((api) => {
      api
        .defaultSession()
        .viewOther()
        .setPlacements([placementId])
        .load()
        .then((response) => {
          if (custom.getAttribute("debugtrending")) {
            console.log("search trending response", response);
          }
          if (response) {
            custom.handleSearchTrendingResponse(response);
          }
        });
    });
  },
  handleSearchTrendingResponse: function (result) {
    if (!result.recommendations[theme.settings.nostoSearchPlacementId]) {
      return;
    }

    let slotId = result.recommendations[theme.settings.nostoSearchPlacementId] && result.recommendations[theme.settings.nostoSearchPlacementId].params ? result.recommendations[theme.settings.nostoSearchPlacementId].params.nosto : '';
    let products = result.recommendations[theme.settings.nostoSearchPlacementId].products;

    if (products) {
      products = products.slice(0, 4);
      products.map((product) => {
        let productUrl = product.url;
        productArr = productUrl.split("/");
        let productHandle = productArr[productArr.length - 1];
        if (productHandle) {
          let sectionContainer = document.querySelector('.trending-products');
          sectionContainer.innerHTML += `<li class="product-trending-${productHandle}"></li>`;
          productCardElems.getPdpItem(productHandle, false, 'trending', false, slotId);
        }
      });
    }
  },
  cleanNav: function (str) {
    let cleanedString = str.replace(/[\t\n\r]+/g, "");
    //remove tabs
    cleanedString = cleanedString.replace(/\t/g, "");
    cleanedString = cleanedString.replace(/ {2,}/g, " "); // Strip 2 or more spaces
    cleanedString = cleanedString.replace(/, ]/g, ']');
    cleanedString = cleanedString.replace(/,]/g, ']');//There's a scenario where the json object is not valid and has a trailing comma due to the date being invalid but liquid is checking for last item in loop
    // Parse the cleaned string as JSON
    try {
      const parsedJSON = JSON.parse(cleanedString);
      return parsedJSON;
    } catch (error) {
      console.error("Invalid JSON string:", error);
      return null; // Or you can throw an error or handle it as needed
    }
  },
  fetchEndBound: function (defEndBound) {
    let totalProducts = 10;
    if (window.visualViewport.width > 1000) {
      return totalProducts * 200;
    }
    return defEndBound;
  },
  hideAllSizeHovers: function () {
    this.hoverState = {};
    let sizeContainers = document.querySelectorAll(".size-container");
    if (sizeContainers && sizeContainers.length > 0) {
      for (i = 0; i < sizeContainers.length; i++) {
        let container = sizeContainers[i];

        if (container) {
          container.style.display = "none";
        }
      }
    }
  },

  productSizeHover: function (product_id, sender) {
    if (this.isMobileBrowser()) {
      let productCard = sender.parentNode.parentNode;
      let quickView = productCard.querySelector("quick-view");
      if (!quickView) {
        productCard = sender.parentNode.parentNode.parentNode;
        quickView = productCard.querySelector("quick-view");
      }
      if (quickView) {
        quickView.click();
      }
    } else if (!this.hoverState[product_id]) {
      this.hoverState = {};
      this.hoverState[product_id] = true;
      this.hideAllSizeHovers();
      let containerId = "size_container_" + product_id;
      let containerElem = document.getElementById(containerId);
      if (containerElem) {
        containerElem.style.display = "block";
      }
      let optionElem = document.getElementById(`optionValues_${product_id}`);
      if (optionElem) {
        let optionValues = optionElem.value;
        let disabledValues = document.getElementById(`disabledValues_${product_id}`).value;
        custom.createButtonFilters(optionValues, product_id, false, false, true, product_id, disabledValues);
      }
    }
  },
  trackNostoSearchSubmit: function (searchTerm) {
    if (custom.getAttribute("debug_tracking")) {
      console.log({ 'method': 'trackNostoSearchSubmit: ', 'apicall': 'api.recordSearchSubmit', 'searchTerm': searchTerm });
    }
    nostojs(api => {
      const query = searchTerm
      api.recordSearchSubmit(query)
    })
  },
  trackNostoRecommendationsCartAdd: function (productId, slotId) {
    if (custom.getAttribute("debug_tracking")) {
      console.log({ 'method': 'trackNostoRecommendationsCartAdd: ', 'apicall': 'api.recommendedProductAddedToCart', 'productId': productId, 'slotId': slotId });
    }
    nostojs(api => {
      api.recommendedProductAddedToCart(productId, slotId);
    });
  },
  trackNostoCartAdd: function (productId, url) {
    if (url.indexOf("http" == -1)) {
      //if the url doesnt contain the domain, add it here
      let domain = window.location.origin;
      url = domain + url;
    }
    let searchPage = window.location.href.indexOf("/search") != -1;
    let categoryPage = window.location.href.indexOf("/collections") != -1;
    let type = '';

    if (searchPage) {
      type = 'serp';
    }
    else if (categoryPage) {
      type = 'category';
    }
    if (custom.getAttribute("debug_tracking")) {
      console.log({ 'method': 'trackNostoCartAdd ', 'apicall': 'api.recordSearchAddToCart', 'productId': productId, 'url': url, 'type': type });
    }

    nostojs(api => {
      let hit = {
        productId: productId,
        url: url,
      }
      api.recordSearchAddToCart(type, hit)
    });
  },
  trackNostoSearchClick: function (productId, url, type) {
    if (url.indexOf("http" == -1)) {
      //if the url doesnt contain the domain, add it here
      let domain = window.location.origin;
      url = domain + url;
    }
    if (custom.getAttribute("debug_tracking")) {
      console.log({ 'method': 'trackNostoSearchClick: ', 'apicall': 'api.recordSearchClick', 'productID': productId, 'URL': url, 'Type': type });
    }
    nostojs(api => {
      let hit = {
        productId: productId,
        url: url,
      }
      api.recordSearchClick(type, hit);
    });
  },
  trackNostoCategoryClick: function (productId, url) {
    if (url.indexOf("http" == -1)) {
      //if the url doesnt contain the domain, add it here
      let domain = window.location.origin;
      url = domain + url;
    }
    if (custom.getAttribute("debug_tracking")) {
      console.log({ 'method': 'trackNostoSearch: ', 'apicall': 'api.recordSearch', 'productId': productId, 'url': url });
    }

    nostojs(api => {
      let hit = {
        productId: productId,
        url: url,
      }
      api.recordSearchClick('category', hit);
    });
  },
  trackNostoCategoryPage: function (searchRequest, searchResult) {//Impressions
    if (custom.getAttribute("debug_tracking")) {
      console.log({ 'method': 'trackNostoCategoryPage: ', 'apicall': 'api.recordSearch', 'SearchRequest': searchRequest, 'SearchResult': searchResult });
    }
    let option = {};
    option.isKeyword = false;
    nostojs(async (api) => {
      api.recordSearch(
        'category',
        searchRequest,
        searchResult,
        {
          isKeyword: false
        }
      )
    });
  },
  trackNostoSearch: function (type, searchRequest, searchResult, options, searchTerm) {//Impressions
    searchRequest = {
      query: searchTerm,
      products: {
        sort: [{ field: "price", order: "asc" }]
      }
    }

    if (custom.getAttribute("debug_tracking")) {
      console.log({ 'method': 'trackNostoSearch: ', 'apicall': 'api.recordSearch', 'Type': type, 'SearchRequest': searchRequest, 'SearchResult': searchResult, 'options': options });
    }

    nostojs(async (api) => {
      api.recordSearch(
        type,
        searchRequest,
        searchResult,
        options
      )
    })
  },
  trackNostoClick: function (slotId, productId) {
    if (custom.getAttribute("debug_tracking")) {
      console.log({ 'method': "trackNostoClick", 'apicall': 'api.recordAttribution', 'SlotID': slotId, 'ProductID': productId });
    }
    nostojs(api => api.recordAttribution({
      type: "vp",
      target: productId,
      ref: slotId,
      refType: "api"
    })
      .done()
    );
  },
  linkToKeywordSearch: function (url) {
    if (!custom.getAttribute("debug_tracking")) {
      location.href = url;
    }
  },
  linkToURL: function (url, anchor) {
    let searchPage = window.location.href.indexOf("/search") != -1;
    let categoryPage = window.location.href.indexOf("/collections") != -1;
    let sectionContainerElem = anchor.closest('.shopify-section');
    let sectionSearchContainerElem = anchor.closest('.thb-predictive-search--promotion-products');
    let recordAttr = false;
    if (sectionSearchContainerElem) {
      recordAttr = true;
    }
    else if (sectionContainerElem) {
      let sectionId = sectionContainerElem.getAttribute('id');
      if (sectionId && sectionId.indexOf('featured_collection') != -1) {
        recordAttr = true;
      }
    }

    if (recordAttr && anchor && anchor.getAttribute("nosto-slot-id")) {
      let slotId = anchor.getAttribute("nosto-slot-id");
      let productId = anchor.getAttribute("product-id");
      custom.trackNostoClick(slotId, productId);
    }
    else if (sectionSearchContainerElem) {
      if (anchor && anchor.getAttribute("nosto-slot-id")) {
        let slotId = anchor.getAttribute("nosto-slot-id");
        let productId = anchor.getAttribute("product-id");
        custom.trackNostoClick(slotId, productId);
      }
    } else if (searchPage) {
      let type = 'serp';
      if (custom.getAttribute('from_key')) {
        type = 'autocomplete';
      }
      custom.trackNostoSearchClick(anchor.getAttribute("product-id"), url, type);
    } else if (categoryPage) {
      custom.trackNostoCategoryClick(anchor.getAttribute("product-id"), url);
    }
  },
  cartSubmitted: function () {
    return false;
  },
  addSizeToCart: function (size, variant_id, product_id, anchor, handle) {
    loopClassDisplay(".loading-overlay", "flex");
    let slotId = "";
    if (anchor) {
      let anchorLink = anchor.closest('product-card');
      slotId = anchorLink.getAttribute("nosto-slot-id");
    }
    let formData = {
      items: [
        {
          id: variant_id,
          product_id: product_id
        },
      ],
    };

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        return response.json();
      })
      .then((cart) => {
        let productsContainer = anchor.closest('.collection');
        if (productsContainer) {
          let url = `/products/${handle}?variant=${variant_id}`;
          custom.trackNostoCartAdd(product_id, url);
        }
        else if (slotId) {
          custom.trackNostoRecommendationsCartAdd(product_id, slotId);
        }
        fetchCartItems();
      })
      .catch((error) => {
        console.error("Error:", error);
      });

    return false;
  },
  addSingleSizeToCart: function (product_id) {
    loopClassDisplay(".loading-overlay", "flex");

    let formData = {
      items: [
        {
          id: product_id,
        },
      ],
    };
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        return response.json();
      })
      .then((cart) => {
        fetchCartItems();
      })
      .catch((error) => {
        console.error("Error:", error);
      });

    return false;
  },
  closeSizeOverlay: function () {
    this.hideAllSizeHovers();
  },
  convertFilterToValidJson: function (json_str) {
    if (json_str) {
      json_str = json_str.replace('}{', '},{');
      json_str = json_str.replace(/value/g, '"value"');
      json_str = json_str.replace(/field/g, '"field"');
    }
    return json_str;
  },
  paginateClicked: function (collectionId,
    resultsId,
    sort,
    pageNum,
    filter,
    filterValid,//This is needed to be able to use a valid json object. The above filter is for graphQL which is not a valid json structure
    use_default,
    allow_scroll) {
    custom.updateFilterUrl(pageNum);
    custom.filterNostoProducts(collectionId,
      resultsId,
      sort,
      pageNum,
      filter,
      filterValid,//This is needed to be able to use a valid json object. The above filter is for graphQL which is not a valid json structure
      use_default,
      allow_scroll);
  },
  filterNostoProducts: function (
    collectionId,
    resultsId,
    sort,
    pageNum,
    filter,
    filterValid,//This is needed to be able to use a valid json object. The above filter is for graphQL which is not a valid json structure
    use_default,
    allow_scroll
  ) {
    if (sort) {
      this.filters.sort = sort;
    }

    if (!this.pageSet) {
      let sortFilter = custom.getAttribute('filter.sort');
      let filterUrl = custom.getAttribute('filter');
      if (sortFilter) {
        this.filters.sort = sortFilter;
        let sortContainer = document.getElementById('nosto-sort-list');
        if (sortContainer) {
          window.onload = function () {
            sortContainer.querySelectorAll('li').forEach((item) => {
              let btn = item.querySelector('.custom-select--item-active');
              let val = btn.getAttribute('data-value');
              if (val == sortFilter) {
                document.getElementById('nosto-search').querySelector('.custom-select--text').innerHTML = btn.innerHTML;
              }
            });
          };
        }
      }
      if (filterUrl) {
        let filters = filterUrl.split("||");
        this.filtersArray = filters;
        filter = "";
        filters.forEach((ft, ftidx) => {
          if (ft) {
            let filterArr = ft.split("*");
            let param = filterArr[0];
            let val = filterArr[1];
            let outputValue = `"${val}"`;
            if (val && val.indexOf(",") != -1) {
              outputValue = "";
              let valArr = val.split(",");
              valArr.forEach((output, idx) => {
                outputValue += `"${output}"`
                if ((idx + 1) < valArr.length) {
                  outputValue += ',';
                }
              });
            }
            filter += `{field: "${param}",value: [${outputValue}]}`;
            if ((ftidx + 1) < filters.length) {
              filter += ',';
            }
          }
        })
        filter = `[${filter}]`;
        let jsonStr = custom.convertFilterToValidJson(filter);
        filterValid = jsonStr;
      }
    }

    if (filter) {
      this.filters.filter = filter;
    }
    if (filterValid) {
      this.filters.filterValid = filterValid;
    }
    this.pageSet = true;
    if (collectionId) {
      this.filters.collectionId = collectionId;
    }
    if (resultsId) {
      this.filters.resultsId = resultsId;
    }

    if (!pageNum) {
      pageNum = 0;
      if (custom.getAttribute('page')) {
        pageNum = custom.getAttribute('page');
      }
    }
    this.filters.pageNum = pageNum;
    collectionId = this.filters.collectionId;
    resultsId = this.filters.resultsId;
    sort = this.filters.sort;
    pageNum = this.filters.pageNum;
    filter = this.filters.filter;
    if (filter) {
      let filterObj = JSON.parse(this.filters.filterValid);
      let activeFacets = document.querySelector('.active-facets');
      activeFacets.innerHTML = "";
      if (activeFacets) {
        let divs = activeFacets.querySelectorAll('.active-facets__button');
        divs.forEach(div => div.remove());
        filterObj.forEach((ft) => {
          ft.value.forEach((val) => {
            let filterRemove = this.fetchLinkTemplate(val, ft.field);
            let testElem = document.getElementById(`${ft.field}${val}`);
            if (testElem) {
              activeFacets.insertAdjacentHTML("afterbegin", filterRemove);
            }
          });
        });
      }
    }
    let resultsDiv = document.getElementById(resultsId);
    if (!resultsDiv) {
      return false;
    }
    if (allow_scroll) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }

    let field = "price";
    if (sort == "newest") {
      sort = "desc";
      field = "datePublished";
    }
    let filterJson = "";
    if (filter) {
      filterJson = `filter: ${filter}`;
    }

    let sortField = "";
    let categoryField = `categoryId: "${collectionId}"`;
    if (sort != "") {
      sortField = `
        sort: [{field: "${field}", order: ${sort}}]
      `;
    }
    if (!collectionId) {
      categoryField = "";
    }
    let accountId = custom.currAccountId;
    if (!accountId) {
      accountId = theme.settings.nostoId;
      if (use_default) {
        accountId = theme.settings.defaultNostoId;
        localStorage.setItem("use-default-account-id", 1);//If we set default this was due to a fail request so make sure we use the default account id from now on
      }
    }
    if (localStorage.getItem("use-default-account-id") == 1) {
      accountId = theme.settings.defaultNostoId;
    }
    let searchQuery = "";
    if (custom.getAttribute('q')) {
      searchQuery = `query: "${custom.getAttribute('q')}",`;
    }
    let pageCt = this.paginationCt ? this.paginationCt : 0;
    let fromCt = pageNum * pageCt;
    let query = `query {
        search (accountId: "${accountId}", ${searchQuery}
          products: {
            ${categoryField}${sortField}
            size: ${this.paginationCt}
            from: ${fromCt}
            ${filterJson}
          }) 
          {
            redirect
            products {
              hits {
                name
                thumbUrl
                price
                listPrice
                productId
                url
              }
              total
            }
        }
      }`;

    resultsDiv.innerHTML = "";
    if (custom.getAttribute("debugrec")) {
      console.log("graphql request", query);
    }
    fetch("https://search.nosto.com/v1/graphql", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        query: query,
      }),
    })
      .then((res) => res.json())
      .then((result) => {
        let redirect;
        if(result && result.data && result.data.search) {
          redirect = result.data.search.redirect;
        }
        if (redirect) {
          location.href = redirect;
          return;            
        }
        let searchTerm = custom.getAttribute('q');
        if (custom.getAttribute('q') && !custom.getAttribute("from_key")) {
          custom.trackNostoSearchSubmit(searchTerm);
        }
        if (custom.getAttribute("from_key") == 'true') {
          let option = {};
          option.isKeyword = true;
          custom.trackNostoSearch("autocomplete", query, result.data.search, option, searchTerm);
        }
        else if (custom.getAttribute('q')) {
          custom.trackNostoSearch("serp", query, result.data.search, null, searchTerm);
        }

        if (custom.getAttribute("debugrec")) {
          console.log("graphql response", result);
        }
        let hasProducts = false;
        if (result.data.search && result.data.search.products) {
          let hits = result.data.search.products.hits;
          hasProducts = hits.length > 0;
        }
        let errors = result.errors;
        let hasError = false;
        if (errors && errors.length > 0) {
          hasError = true;
          console.error('Nosto API fetch failed with error: ' + JSON.stringify(errors, null, 4));
        }
        if (custom.getAttribute("no-nosto") == "true") {//Use this to emulate nosto being down
          custom.handleNostoNoResults();
        }
        else if (hasError && !hasProducts) {
          if (!use_default) {
            custom.filterNostoProducts(collectionId, resultsId, sort, pageNum, filter, filterValid, true);
          } else {
            custom.handleNostoNoResults();
          }
        }
        else if (result && result.data) {
          let categoryQuery = {
            products: {
              "categoryId": collectionId,
              "size": this.paginationCt,
              "from": fromCt
            }
          };
          if (filter) {
            let filterNoQuotesConverted = sanitizeAndConvertToJson(filterJson.replace("filter: ", ""));
            let jsonTrackFilter = JSON.parse(filterNoQuotesConverted);
            categoryQuery = {
              products: {
                "categoryId": collectionId,
                "size": this.paginationCt,
                "from": fromCt,
                "filter": jsonTrackFilter
              }
            };
          }
          if (!custom.getAttribute('q')) {
            custom.trackNostoCategoryPage(categoryQuery, result.data.search);
          }
          custom.currAccountId = accountId;
          let hits = result.data.search.products.hits;
          let totalProducts = result.data.search.products.total;
          if (totalProducts == 0) {
            custom.handleNostoNoResults();
          }
          let numberOfPages = Math.ceil(totalProducts / this.paginationCt);
          let shop_symbol = custom.fetchShopSymbol();
          let promotionsShown = [];
          if (custom.getAttribute('q')) {
            let resultTxtElem = document.querySelector('.template-header--description');
            if (resultTxtElem) {
              //search the text and remove all numeric digits, the prepend the text with hits.length
              let resultTxt = resultTxtElem.innerHTML;
              resultTxt = resultTxt.replace(/(\d+)/g, '');
              resultTxt = `${hits.length} ${resultTxt}`;
              resultTxtElem.innerHTML = resultTxt;
              resultTxtElem.style.display = 'block';
            }
          }
          hits.map((product, idx) => {
            if (collectionPromotions && collectionPromotions[idx + 1]) {
              custom.generateFillerTile(collectionPromotions[idx + 1]);
              promotionsShown.push(idx + 1);
            }
            let productUrl = product.url;
            productArr = productUrl.split("/");
            let productHandle = productArr[productArr.length - 1];
            if (productHandle) {
              document.getElementById("nostoProducts").innerHTML +=
                custom.prefetchProduct(productHandle, product);
              productCardElems.getPdpItem(productHandle, false);
            }
          });
          collectionPromotions.forEach((collectionPromo, idx) => {
            if (idx + 1 > hits.length && !promotionsShown.includes(idx + 1)) {
              custom.generateFillerTile(collectionPromo);
            }
          });
          let pages = "";
          for (i = 0; i < numberOfPages; i++) {
            let className = "";
            if (pageNum == i) {
              className = "active";
            }
            pages += `<li class="${className}"><a href="javascript:void(custom.paginateClicked('${collectionId}', '${resultsId}', '${sort}',${i},null,null,false,true));">${i + 1
              }</a></li>`;
          }
          document.getElementById("nosto-collection-pagination").innerHTML =
            pages;
          document.getElementById("totalProducts").innerHTML = totalProducts;
          let productText = document.getElementById('productText').innerHTML;

          document.querySelector('.facets__label').innerHTML = `${totalProducts} ${productText}`;
          if (!custom.filtersChecked) {
            custom.checkFilters(custom.filtersArray);
          }
        } else {
          custom.handleNostoNoResults(collectionId);
        }
      });
  },
  handleNostoNoResults: function () {
    let handle = location.href.split('/').pop().split('?')[0];
    //location.href = '/pages/collection-no-nosto/' + handle;
  },
  checkFilters: function (filters) {
    custom.filtersChecked = true;
    filters.forEach((ft, ftidx) => {
      if (ft) {
        let filterArr = ft.split("*");
        let param = filterArr[0];
        let val = filterArr[1];
        if (val.indexOf(",") != -1) {
          let valArr = val.split(",");
          valArr.forEach((output, idx) => {
            let elem = document.getElementById(`${param}${output}`);
            if (elem) {
              elem.checked = true;
            }
          });
        } else {
          let elem = document.getElementById(`${param}${val}`);
          if (elem) {
            elem.checked = true;
          }
        }
      }
    })
  },
  generateFillerTile: function (collectionPromo) {
    let image = collectionPromo.image;
    let heading = collectionPromo.heading;
    let bodyColor = collectionPromo.body_color;
    let useTextButton = collectionPromo.use_text_button;
    let blackOverlay = collectionPromo.black_overlay;
    let buttonStyle = collectionPromo.button_style;
    let contentPosition = collectionPromo.content_position;
    let contentAlignment = collectionPromo.content_alignment;
    let url = collectionPromo.url;
    let buttonUrl = collectionPromo.button_url;
    let description = collectionPromo.description;
    let buttonLabel = collectionPromo.button_label;
    let columnWidth = collectionPromo.columns;
    let descriptionContent = "";
    if (description) {
      descriptionContent = `<p style="color: var(--color-${bodyColor})" class="mo-promo-description" data-live-text-setting="">${description}</p>`;
    }
    let buttonLabelContent = "";
    if (buttonLabel) {
      if (useTextButton) {
        buttonLabelContent = `<a class="text-button ${buttonStyle} text-button--has-icon" href="${buttonUrl}" data-live-text-setting="">${buttonLabel}</a>`
      } else {
        buttonLabelContent = `<a class="mo-promo-button button ${buttonStyle} medium" href="${buttonUrl}" data-live-text-setting="">${buttonLabel}</a>`;
      }
    }
    let headingContent = "";
    if (heading) {
      headingContent = `<h4 style="color: var(--color-${bodyColor})" class="mo-promo-heading" data-live-text-setting="">${heading}</h4>`;
    }
    let overlay = "";
    if (blackOverlay > 0) {
      overlay = `--overlay-color-rgb: 0,0,0;  --overlay-opacity: ${blackOverlay}`;
      console.log(overlay);
    }

    let infoSection = "";
    if (heading || description || buttonLabel) {
      infoSection = `
      <div class="gallery--item-content content-${contentPosition} text-${contentAlignment}">
        <div>
          ${headingContent}
          ${descriptionContent}
          ${buttonLabelContent}
        </div>
      </div>
    `;
    }

    let liUrl = "";
    let imageSection = `<img class=" " width="2760" height="1765" data-sizes="auto" src="${image}" data-srcset="${image}" fetchpriority="auto" alt="" style="object-position: 50.0% 50.0%;">`;
    if (url) {
      liUrl = `onclick="location.href='${url}'"`;
      imageSection = `<a href="${url}" class="gallery--item-link">${imageSection}</a>`;
    }

    document.getElementById("nostoProducts").innerHTML +=
      `
      <li ${liUrl} class="promotion-column column promotion-column-width--${columnWidth} product-columns-4 pointer">
        <div onclick="location.href='${url}'" class="gallery--item"  style="${overlay}">
          <figure class="aspect-ratio">
            ${imageSection}
            <noscript>
              <img width="2760" height="1765" sizes="auto" src="${image}" srcset="${image}" alt="${heading}" fetchpriority="auto" style="object-position: 50.0% 50.0%;" />
            </noscript>
            ${infoSection}
          </figure>
        </div>
      </li>
      `
  },
  filterNostoSearch: function (searchTerm, resultsDiv, sort, limit, use_default) {
    let searchPage = window.location.href.indexOf("/search") != -1;
    if (!searchPage) {
      resultsDiv.innerHTML = `<div id="search-box"></div>`;
      resultsDiv = document.getElementById("search-box");
    }
    let field = "price";
    if (sort == "newest") {
      sort = "desc";
      field = "datePublished";
    }

    let accountId = custom.currAccountId;
    if (!accountId) {
      accountId = theme.settings.nostoId;
      if (use_default) {
        accountId = theme.settings.defaultNostoId;
      }
    }
    if (localStorage.getItem("use-default-account-id") == 1) {
      accountId = theme.settings.defaultNostoId;
    }
    if (!limit) {
      limit = 140;
    }
    let query = `query ($query: String) {
        search (
          accountId: "${accountId}", 
          products: {
            size: ${limit}
          }
          query: $query
        ) {
          keywords {
            hits {
              keyword
            }
          }
          redirect
          products {
            hits {
              name
              thumbUrl
              price
              listPrice
              productId
              url
            }
            total
          }
        }
      }`;
    if (sort && sort != "") {
      query = `query ($query: String) {
        search (
          accountId: "${accountId}", 
          query: $query,
          products: {
            sort: [{field: "${field}", order: ${sort}}]
          }) {
          keywords {
            hits {
              keyword
            }
          }
          redirect
          products {
            hits {
              name
              thumbUrl
              price
              listPrice
              productId
              url
            }
            total
          }
        }
      }`;
    }

    if (!searchPage) {
      resultsDiv.innerHTML = `<div><ul id="nostoKeywords"></ul></div>`;
    }

    fetch("https://search.nosto.com/v1/graphql", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        query: query,
        variables: {
          query: searchTerm,
        },
      }),
    })
      .then((res) => res.json())
      .then((result) => {
        let errors = result.errors;
        let hasError = false;
        if (errors && errors.length > 0) {
          hasError = true;
          console.error('Nosto API fetch failed with error: ' + JSON.stringify(errors, null, 4));
        }
        if (hasError) {
          if (!use_default) {
            custom.filterNostoSearch(searchTerm, resultsDiv, sort, limit, true);
          }
        } else {
          if (custom.getAttribute('q') && !custom.getAttribute("from_key")) {
            let redirect;
            if(result && result.data && result.data.search) {
              redirect = result.data.search.redirect;
            }
            if (redirect) {
              location.href = redirect;
            } else {
              custom.trackNostoSearchSubmit(searchTerm);
            }
          }
          if (custom.getAttribute("from_key") == 'true') {
            let option = {};
            option.isKeyword = true;
            custom.trackNostoSearch("autocomplete", query, result.data.search, option, searchTerm);
          }
          else if (custom.getAttribute('q')) {
            custom.trackNostoSearch("serp", query, result.data.search, null, searchTerm);
          } else {//Non search page
            custom.trackNostoSearch("autocomplete", query, result.data.search, null, searchTerm);
          }
          custom.currAccountId = accountId;
          let hits = result.data.search.products.hits;
          let keywords_nosto = result.data.search.keywords.hits;
          let searchResults = "";

          if (!searchPage) {
            let nostoKeywordsElem = document.getElementById("nostoKeywords");
            if (nostoKeywordsElem) {
              nostoKeywordsElem.innerHTML = "";
              keywords_nosto.map((item) => {
                let keyword = item.keyword;
                let locale = "";
                if (theme.settings.locale) {
                  locale = '/' + theme.settings.locale
                }
                nostoKeywordsElem.innerHTML += `<li><a onclick="custom.linkToKeywordSearch('${locale}/search?q=${keyword}&from_key=true');" href="#">${keyword}</a></li>`;
              });
            }
            resultsDiv.innerHTML += `<div id="search-results"></div>`;
            searchResults = document.getElementById("search-results");
            searchResults.innerHTML = "";
          }
          if (hits.length == 0) {
            notFound = document.getElementById("notFound");
            if (notFound) {
              notFound.classList.add("show");
            }
          }
          else {
            hits.map((product) => {
              let productUrl = product.url;
              productArr = productUrl.split("/");
              let productHandle = productArr[productArr.length - 1];
              let nostoSearchElem = document.getElementById("nostoSearch");
              if (nostoSearchElem && searchPage) {
                if (productHandle) {
                  nostoSearchElem.innerHTML += custom.prefetchProduct(
                    productHandle,
                    product
                  );
                  productCardElems.getPdpItem(productHandle, false, null, null, null, true);
                }
              } else {
                if (productHandle) {
                  searchResults.innerHTML += `<div class="product-${productHandle}"></div>`;
                  productCardElems.getPdpItem(productHandle, true, null, null, null, true);
                }
              }
            });
          }
        }
      });
  },
  updateNostoSearch: function (terms, resultsDiv, sort) {
    this.filterNostoSearch(terms, resultsDiv, sort);
  },
  linkToProduct: function (productId, url, from_search) {
    if (from_search) {
      custom.trackNostoSearchClick(productId, url, 'autocomplete');
    }
    if (!custom.getAttribute("debug_tracking")) {
      location.href = url;
    }
  },
  fetchShopSymbol: function () {
    let shop_symbol = theme.settings.money_with_currency_format.trim();
    if (
      shop_symbol.substring(shop_symbol.length - 1) !== "}" &&
      shop_symbol.substring(shop_symbol.length - 1).length > 0
    ) {
      shop_symbol = shop_symbol.substring(shop_symbol.length - 1);
    } else {
      shop_symbol = shop_symbol.substring(0, 1);
    }
    return shop_symbol;
  },
  prefetchProduct: function (productHandle, product) {
    let shop_symbol = custom.fetchShopSymbol();
    let price = shop_symbol + product.price;
    let title = product.name;
    if (theme.settings.lang != "fr") {
      price = "";
      title = "";
    }
    let productTemplate = `
              <li class="column product-${productHandle}">
                <product-card class="product-card text-left product-card--content-spacing-false product-card--border-false has-shadow--false">
                  <div class="loading-icon">
                    <svg
                    aria-hidden="true"
                    focusable="false"
                    role="presentation"
                    class="spinner"
                    viewBox="0 0 66 66"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle class="spinner-path" fill="none" stroke-width="6" cx="33" cy="33" r="30" stroke="var(--color-body)"></circle>
                    </svg>
                  </div>
                  <img width="304" height="380" class="loading-product-image" src="${product.thumbUrl}" alt="${product.name}">
                  <div class="product-card-info-outer">
                    <div class="product-card-info" style="padding-top:10px;">
                      <span class="price">
                        <ins><span class="amount ">${price}</span></ins>
                      </span>
                      <a href="#" class="product-card-title"><h2>${title}</h2></a> 
                    </div>
                  </div>
                </product-card>
              </li>`;
    return productTemplate;
  },

  updateFlickity: function (sliderId) {
    let slider = document.getElementById(sliderId);
    if (slider) {
      flkty = Flickity.data(slider);
      if (flkty) {
        flkty.reloadCells();
      }
    }
  },
};

function loopClassDisplay(whichClass, cssDisplay) {
  const elements = document.querySelectorAll(whichClass);
  elements.forEach((element) => {
    element.style.display = cssDisplay;
  });
}

async function fetchCartItems() {
  try {
    const response = await fetch("/cart.js", { cache: "no-store" });
    if (!response.ok) {
      throw new Error("Something wrongs");
    }
    const cart = await response.json();

    document.querySelector(".thb-item-count").textContent = cart.item_count;
    let drawerUrl = `/collections/recommendations/products?section_id=cart-drawer`
    if (theme.settings.locale != "") {
      drawerUrl = `/${theme.settings.locale}/collections/recommendations/products?section_id=cart-drawer`;
    }
    fetch(drawerUrl)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        let selectors = [
          "side-panel-content",
          "side-panel-footer",
          "side-panel-header",
        ];
        let footerDiv = document
          .querySelector(".cart-drawer")
          .querySelector(".side-panel-footer");
        if (!footerDiv) {
          document
            .querySelector(".cart-drawer")
            .querySelector(
              ".side-panel-inner"
            ).innerHTML += `<div class="side-panel-footer"></div>`;
        }
        selectors.map((selector) => {
          let input = html.querySelector(`.${selector}`);
          if (input) {
            document
              .querySelector(".cart-drawer")
              .querySelector(`.${selector}`)
              .replaceWith(html.querySelector(`.${selector}`));
          }
        });
        document.querySelector(".thb-secondary-cart").click();
      });

    this.loopClassDisplay(".loading-overlay", "none");
    return cart;
  } catch (error) {
    console.error("Fetch error:", error);
  }
}

var prevScrollpos = window.scrollY;
window.onscroll = function () {
  const isCollectionPage =
    document.querySelector(".template-collection") != null;
  const isHomePage = document.querySelector(".template-index") != null;
  const hasFacetsBar = document.querySelector(".facets--bar") != null;

  var currentScrollPos = window.scrollY;

  //TOP SEARCH BAR
  let mobileSearchContainer = document.getElementById("mobileSearchContainer");
  //TODO: reimplement static scroll
  return false;
  if (mobileSearchContainer) {
    if ((isCollectionPage || isHomePage) && custom.isMobile()) {
      // Only execute the scroll behavior on mobile devices
      let headerSection = document.querySelector(".facets--bar");

      if (currentScrollPos > 100) {
        document.getElementById("mobileSearchContainer").style.display = "none";
        document.querySelector(".logolink").style.display = "none";
        document.querySelector(".searchLogo").style.display = "block";
      } else {
        document.getElementById("mobileSearchContainer").style.display = "";
        document.querySelector(".logolink").style.display = "";
        document.querySelector(".searchLogo").style.display = "none";
      }

      prevScrollpos = currentScrollPos;
    } else {
      document.getElementById("mobileSearchContainer").style.display = "none";
      document.querySelector(".logolink").style.display = "block";
      document.querySelector(".searchLogo").style.display = "none";
    }
  }

  //FILTER BAR
  if (isCollectionPage && hasFacetsBar) {
    let topHeight = document.querySelector(".image-with-text")
      ? document.querySelector(".image-with-text").offsetHeight + 125
      : 0; //Desktop default
    if (custom.isMobile()) {
      topHeight = 350;
    }
    if (currentScrollPos > topHeight) {
      let headerHeight = document.querySelector(".header-section").offsetHeight;
      let headerWidth = document.querySelector(".header--inner").offsetWidth;
      document.querySelector(".facets--bar").style.position = "fixed";
      document.querySelector(".facets--bar").style.width = headerWidth + "px";
      if (custom.isMobile()) {
        headerHeight++;
      }
      document.querySelector(".facets--bar").style.top =
        headerHeight - 11 + "px";
      document.querySelector(".facets--bar").style.padding = "10px";
    } else {
      document.querySelector(".facets--bar").style.position = "";
    }
  }
};

var productCardElems = {
  points: function () {
    return `<div class="points-price">
          <button class="dim-btn-gradient">27 Points
            <svg class="info-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_4312_47907)">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M8 0.761905C4.00251 0.761905 0.761905 4.00251 0.761905 8C0.761905 11.9975 4.00251 15.2381 8 15.2381C11.9975 15.2381 15.2381 11.9975 15.2381 8C15.2381 4.00251 11.9975 0.761905 8 0.761905ZM0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z"
                        fill="#555555"></path>
                    <path
                        d="M7.5 4H8.479V5.012H7.5V4ZM7.5 6.0625H8.479V12.0025H7.5V6.0625Z"
                        fill="#1F1E21"></path>
                </g>
                <defs>
                    <clippath id="clip0_4312_47907">
                        <rect width="16" height="16"
                            fill="white"></rect>
                    </clippath>
                </defs>
            </svg>
          </button>
      </div>`;
  },
  swatches: function () {
    return `<div class="variations variations--siblings">
      <fieldset
              class="product-form__input product-form__input--siblings"
              style="--siblings-margin:px">
  
              <label class style="--option-color: #f5f3fe;">
                  <a
                      href="javascript:void(custom.updateProductCard('8034001354890', '//cdn.shopify.com/s/files/1/0344/6374/4138/files/D02BKC1-4KQ_01_5a82d62f-af78-4a1d-8417-3d80e7985f24.jpg?crop=center&amp;height=700&amp;v=1712866185&amp;width=596', '//cdn.shopify.com/s/files/1/0344/6374/4138/files/D02BKC1-4KQ_01_5a82d62f-af78-4a1d-8417-3d80e7985f24.jpg?v=1712866185&amp;width=72', '//cdn.shopify.com/s/files/1/0344/6374/4138/files/D02BKC1-4KQ_02_937a425e-b316-4f92-8479-5d2fcd8b17fa.jpg?crop=center&amp;height=700&amp;v=1712866185&amp;width=596', '//cdn.shopify.com/s/files/1/0344/6374/4138/files/D02BKC1-4KQ_02_937a425e-b316-4f92-8479-5d2fcd8b17fa.jpg?v=1712866185&amp;width=72', 'Generous MOD Dim underwire bra with white embroidery', '/products/generous-mod-dim-underwire-bra-with-white-embroidery', '$28.69', 'generous-mod-dim-underwire-bra-with-white-embroidery', '8002730983562'));"
                      sib-id="8002730983562"
                      title="Generous MOD Dim underwire bra with white embroidery"></a>
              </label>
          </fieldset></div>`;
  },
  discount: function (percentOff, languageCode, discountPlacement) {
    let classes = "badge onsale";
    if (discountPlacement == "top_right") {
      classes = "badge onsale top right";
    } else if (discountPlacement == "top_left") {
      classes = "badge onsale top left";
    }
    classes += " " + discountPlacement;
    if (languageCode == "en") {
      percentOff *= -1;
      return `<span class="${classes}"><span class="badge-amount">${percentOff}% Off</span></span>`;
    } else {
      return `<span class="${classes}"><span class="badge-amount">${percentOff}%</span></span>`;
    }
  },
  quickView: function (handle) {
    return `
        <quick-view class="product-card-quickview" data-product-handle="${handle}" tabindex="-1">
          <div class="loading-overlay">
            <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                <circle class="spinner-path" fill="none" stroke-width="6" cx="33" cy="33" r="30" stroke="var(--color-body)"></circle>
            </svg>
          </div>
          <span>Quick view</span>
      </quick-view>`;
  },
  images: function (primaryImageSrc, secondaryImageSrc) {
    return `
        <img class="no-blur product-secondary-image lazyautosizes lazyloaded" width="1200" height="1200" data-sizes="auto" src="${secondaryImageSrc}" alt>
        <img class="no-blur product-primary-image lazyautosizes lazyloaded" width="1200" height="1200" data-sizes="auto" src="${primaryImageSrc}" alt>`;
  },
  getPageItem: function (handle, className) {
    let pageUrl = this.parsePageUrl(handle);
    fetch(pageUrl)
      .then((response) => {
        return response.text();
      })
      .then((html) => {
        let prod = new DOMParser()
          .parseFromString(html, "text/html")
          .querySelector(".size-guide");
        if (prod) {
          let prodHTML = prod.innerHTML;
          let elem = document.querySelector("." + className);
          if (elem) {
            elem.innerHTML = prodHTML;
            if (prod.classList.contains("women")) {
              addScriptAfterLoad(
                document
                  .getElementById("scriptGTwomen")
                  .getAttribute("data-js-url"),
                false
              );
            }
            if (prod.classList.contains("men")) {
              addScriptAfterLoad(
                document
                  .getElementById("scriptGTmen")
                  .getAttribute("data-js-url"),
                false
              );
            }
            if (prod.classList.contains("child")) {
              addScriptAfterLoad(
                document
                  .getElementById("scriptGTchild")
                  .getAttribute("data-js-url"),
                false
              );
            }
          }
        }
      });
  },
  getPdpItem: function (handle, small, sectionId, sectionOnly, slotId, fromSearch) {
    let productUrl = this.parseUrl(handle, small, fromSearch);
    let productCard = "product_card";
    if (small) {
      productCard = "product_card_small";
    }
    fetch(productUrl)
      .then((response) => {
        return response.text();
      })
      .then((html) => {
        let loading = document.querySelector(".loading");
        if (loading) {
          loading.style.display = "none";
        }
        let prod = new DOMParser()
          .parseFromString(html, "text/html")
          .querySelector("." + productCard);
        if (prod) {
          let placeholder = prod.querySelector('.thb-placeholder');
          let anchorLink = prod.querySelector('.product-card-title');
          let imageAnchor = prod.querySelector('.product-featured-image-link');
          if (slotId) {
            if (anchorLink) {
              anchorLink.setAttribute('nosto-slot-id', slotId);
            }

            prod.querySelector('product-card').setAttribute('nosto-slot-id', slotId);
            if (imageAnchor) {
              imageAnchor.setAttribute('nosto-slot-id', slotId);
            }
          }
          let prodHTML = prod.innerHTML;
          let section = "";
          if (sectionId) {
            section = sectionId + "-";
          }
          if (sectionOnly) {
            if (sectionId) {
              if (placeholder) {
                sectionId.style.display = 'none';
                return false;
              } else {
                sectionId.innerHTML = prodHTML;
                sectionId.style.display = '';
              }
            }
          } else {
            let elem = document.querySelector(".product-" + section + handle);
            if (elem) {
              if (placeholder) {
                elem.style.display = 'none';
                return false;
              } else {
                elem.innerHTML = prodHTML;
              }
            }
            let sectionId2 = "product-grid-" + sectionId;
            custom.updateFlickity(sectionId2);
            document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
          }
        }
      });
  },
  parseUrl: function (handle, small, fromSearch) {
    let feedType = "-regular";
    if (small) {
      feedType = "-small";
    }
    let productUrl = `/pages/nosto${feedType}-feed/${handle}`;
    if (theme.settings.locale != "") {
      productUrl = `/${theme.settings.locale}/pages/nosto${feedType}-feed/${handle}`;
    }
    if (fromSearch && small) {
      productUrl += "*from_search";
    }
    return productUrl;
  },
  parsePageUrl: function (handle) {
    let pageUrl = `/${theme.settings.locale}/pages/${handle}`;
    if (!theme.settings.locale) {
      pageUrl = `/pages/${handle}`;
    }
    return pageUrl;
  },
};
custom.updateBreadCrumbs();

async function fetchProductByHandle(handle) {
  const storeDomain = theme.settings.storeDomain;
  const accessToken = theme.settings.accessToken;
  const query = `
  {
    products(first: 1, query: "${handle}") {
      edges {
        node {
          id
          handle
          title
          tags
          productType
          vendor
        }
      }
    }
  }
  `;

  const response = await fetch(
    `https://${storeDomain}/api/2024-07/graphql.json`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": accessToken,
        "Accept-Language": Shopify.locale,
      },
      body: JSON.stringify({ query }),
    }
  );

  if (!response.ok) {
    throw new Error("Network response was not ok " + response.statusText);
  }

  const jsonResponse = await response.json();
  return jsonResponse.data.products.edges[0].node;
}
async function fetchMetaobjectByHandle(handle, type) {
  const storeDomain = theme.settings.storeDomain;
  const accessToken = theme.settings.accessToken;
  const query_collection = `
{
  metaobject(handle: {handle: "${handle}", type: "${type}"}) {
    header: field(key: "header") {
      value
    }
    name: field(key: "name") {
      value
    }
    description: field(key: "description") {
      value
    }
    collections: field(key: "collections") {
      key
      references(first: 10) {
        edges {
          node {
            ... on Collection {
              title
              handle
              image {
                src
              }
            }
          }
        }
      }
    }
  }
}
  `;
  const query_slideshow = `
{
  metaobject(handle: {handle: "${handle}", type: "${type}"}) {
    description1: field(key: "slide_1_description") {
      value
    }
    description2: field(key: "slide_2_description") {
      value
    }
    description3: field(key: "slide_3_description") {
      value
    }
    heading1: field(key: "slide_1_heading") {
      value
    }
    heading2: field(key: "slide_2_heading") {
      value
    }
    heading3: field(key: "slide_3_heading") {
      value
    }
    subheading1: field(key: "slide_1_subheading") {
      value
    }
    subheading2: field(key: "slide_2_subheading") {
      value
    }
    subheading3: field(key: "slide_3_subheading") {
      value
    }
    slide1Button1Text: field(key: "slide_1_button_1_text") {
      value
    }
    slide1Button2Text: field(key: "slide_1_button_2_text") {
      value
    }
    slide1Button3Text: field(key: "slide_1_button_3_text") {
      value
    }
    slide1Button1CollectionURL: field(key: "slide_1_button_1_collection_url") {
      reference {
        ... on Collection {
          handle
        }
      }
    }
    slide1Button2CollectionURL: field(key: "slide_1_button_2_collection_url") {
      reference {
        ... on Collection {
          handle
        }
      }
    }
    slide1Button3CollectionURL: field(key: "slide_1_button_3_collection_url") {
      reference {
        ... on Collection {
          handle
        }
      }
    }
    slide1Button1PageURL: field(key: "slide_1_button_1_page_url") {
      reference {
        ... on Page {
          handle
          onlineStoreUrl
        }
      }
    }
    slide1Button2PageURL: field(key: "slide_1_button_2_page_url") {
      reference {
        ... on Page {
          handle
          onlineStoreUrl
        }
      }
    }
    slide1Button3PageURL: field(key: "slide_1_button_3_page_url") {
      reference {
        ... on Page {
          handle
          onlineStoreUrl
        }
      }
    }
    slide1Button1CustomURL: field(key: "slide_1_button_1_custom_url") {
      value
    }
    slide1Button2CustomURL: field(key: "slide_1_button_2_custom_url") {
      value
    }
    slide1Button3CustomURL: field(key: "slide_1_button_3_custom_url") {
      value
    }
    
    slide2Button1Text: field(key: "slide_2_button_1_text") {
      value
    }
    slide2Button2Text: field(key: "slide_2_button_2_text") {
      value
    }
    slide2Button3Text: field(key: "slide_2_button_3_text") {
      value
    }
    slide2Button1CollectionURL: field(key: "slide_1_button_1_collection_url") {
      reference {
        ... on Collection {
          handle
        }
      }
    }
    slide2Button2CollectionURL: field(key: "slide_1_button_2_collection_url") {
      reference {
        ... on Collection {
          handle
        }
      }
    }
    slide2Button3CollectionURL: field(key: "slide_1_button_3_collection_url") {
      reference {
        ... on Collection {
          handle
        }
      }
    }
    slide2Button1PageURL: field(key: "slide_2_button_1_page_url") {
      reference {
        ... on Page {
          handle
          onlineStoreUrl
        }
      }
    }
    slide2Button2PageURL: field(key: "slide_2_button_2_page_url") {
      reference {
        ... on Page {
          handle
          onlineStoreUrl
        }
      }
    }
   slide2Button3PageURL: field(key: "slide_2_button_3_page_url") {
      reference {
        ... on Page {
          handle
          onlineStoreUrl
        }
      }
    }
    slide2Button1CustomURL: field(key: "slide_2_button_1_custom_url") {
      value
    }
    slide2Button2CustomURL: field(key: "slide_2_button_2_custom_url") {
      value
    }
    slide2Button3CustomURL: field(key: "slide_2_button_3_custom_url") {
      value
    }

    slide3Button1Text: field(key: "slide_3_button_1_text") {
      value
    }
    slide3Button2Text: field(key: "slide_3_button_2_text") {
      value
    }
    slide3Button1CollectionURL: field(key: "slide_3_button_1_collection_url") {
      reference {
        ... on Collection {
          handle
        }
      }
    }
    slide3Button2CollectionURL: field(key: "slide_3_button_2_collection_url") {
      reference {
        ... on Collection {
          handle
        }
      }
    }
    slide3Button3CollectionURL: field(key: "slide_3_button_3_collection_url") {
      reference {
        ... on Collection {
          handle
        }
      }
    }
    slide3Button1PageURL: field(key: "slide_3_button_1_page_url") {
      reference {
        ... on Page {
          handle
          onlineStoreUrl
        }
      }
    }
    slide3Button2PageURL: field(key: "slide_3_button_2_page_url") {
      reference {
        ... on Page {
          handle
          onlineStoreUrl
        }
      }
    }
    slide3Button3PageURL: field(key: "slide_3_button_3_page_url") {
      reference {
        ... on Page {
          handle
          onlineStoreUrl
        }
      }
    }
    slide3Button1CustomURL: field(key: "slide_3_button_1_custom_url") {
      value
    }
    slide3Button2CustomURL: field(key: "slide_3_button_2_custom_url") {
      value
    }
    slide3Button3CustomURL: field(key: "slide_3_button_3_custom_url") {
      value
    }

    image1: field(key: "slide_1_image") {
      reference {
        ... on MediaImage {
          image {
            url
          }
        }
      }
    }
    image1Mobile: field(key: "slide_1_image_mobile") {
      reference {
        ... on MediaImage {
          image {
            url
          }
        }
      }
    }
    image2: field(key: "slide_2_image") {
      reference {
        ... on MediaImage {
          image {
            url
          }
        }
      }
    }
    image2Mobile: field(key: "slide_2_image_mobile") {
      reference {
        ... on MediaImage {
          image {
            url
          }
        }
      }
    }
    video: field(key: "slide_1_video") {
      reference {
        ... on Video {
          sources {
            url
          }
        }
      }
    }
    videoMobile: field(key: "slide_1_video_mobile") {
      reference {
        ... on Video {
          sources {
            url
          }
        }
      }
    }
    slidesURL: field(key: "slides_url") {
      value
    }
    slides: field(key: "slides") {
      reference {
        field
      }
    }
  }
}
  `;
  let query = query_collection;
  if (type == "slideshow") {
    query = query_slideshow;
  }

  const response = await fetch(
    `https://${storeDomain}/api/2024-07/graphql.json`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": accessToken,
        "Accept-Language": Shopify.locale,
      },
      body: JSON.stringify({ query }),
    }
  );

  if (!response.ok) {
    throw new Error("Network response was not ok " + response.statusText);
  }

  const jsonResponse = await response.json();
  return jsonResponse.data.metaobject;
}

function addScriptAfterLoad(src, url_origin = true, callback = null) {
  let path = "";
  if (url_origin) {
    path = path + window.location.origin;
  }
  path = path + src;

  var scriptElement = document.createElement("script");
  scriptElement.type = "text/javascript";
  scriptElement.src = path;
  if (callback) {
    scriptElement.onload = callback;
  }
  document.head.appendChild(scriptElement);
}

function showPass(element) {
  var x = document.getElementById(element);
  if (x.type === "password") {
    x.type = "text";
  } else {
    x.type = "password";
  }
}


function sanitizeAndConvertToJson(inputStr) {
  try {
    const input = JSON.parse(inputStr.replace(/(\w+):/g, '"$1":'));

    const formattedInput = input.map(obj => {
      return Object.fromEntries(
        Object.entries(obj).map(([key, value]) => {
          let formattedKey = /^\w+$/.test(key) ? key : `"${key}"`;
          let formattedValue = Array.isArray(value)
            ? value.map(v => (typeof v === 'number' || !isNaN(v) ? v.toString() : v))
            : value;
          return [formattedKey, formattedValue];
        })
      );
    });
    return JSON.stringify(formattedInput, null, 2);
  } catch (error) {
    console.error("Invalid JSON input", error);
    return null;
  }
}